import { useState, useEffect, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
// Registration entity removed - no longer needed
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Calendar } from "@/components/ui/calendar";
import { toast } from "react-toastify";
import Bugsnag from "@bugsnag/js";
import { useParams, useNavigate } from "react-router-dom";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { addDays, format, startOfDay } from "date-fns";
import { he, enUS } from "date-fns/locale";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  CalendarIcon,
  Heart,
  Users,
  Clock,
  Send,
  CheckCircle,
  Edit3,
  Award,
  Baby,
  CreditCard,
  FileText,
  Gift,
  Check,
  X,
  ShieldCheck,
  KeyRound,
  Loader2,
  Mail,
  Phone,
  Download,
  ArrowLeft,
  ArrowRight,
  Minus,
  Sparkles,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/axios";
import GooglePlacesInput from "@/components/GooglePlacesInput";
import ExpiryPage from "./PackageExpired";
const logoImage = "https://wiwi.gifts/images/wiwi-logo.svg";

// const invoices = [
//     // Sample data for testing - remove this when you have real data
//     {
//       id: 1,
//       date: "2024-01-15",
//       totalAmount: "1,200",
//       type: 2,
//       invoiceURL: "https://www.google.com",
//     },
//     {
//       id: 2,
//       date: "2024-02-20",
//       totalAmount: "850",
//       type: 3,
//       invoiceURL: "https://www.google.com",
//     },
//     {
//       id: 3,
//       date: "2024-03-10",
//       totalAmount: "2,100",
//       type: 4,
//       invoiceURL: "https://www.google.com",
//     },
//   ]
// i18n translations
const translations = {
  he: {
    // General
    appTitle: "טופס רישום לשירות WiWi",
    appSubtitle: "מלאו את הפרטים וניצור עבורכם חוויית אירוע בלתי נשכחת.",
    errorOccured: "אירעה שגיאה. אנא נסה שוב",
    // Event types
    eventTypeSelectionTitle: "בחרו את סוג האירוע",
    eventTypeSelectionSubtitle: "בחירה זו תעזור לנו להתאים את הטופס עבורכם.",
    eventTypes: {
      wedding: "חתונה",
      henna: "חינה",
      bar_bat_mitzvah: "בר/ת מצווה",
      brit: "ברית/ה",
    },

    // Form steps
    formSteps: {
      clientDetails: "פרטי מזמין",
      eventDetails: "פרטי אירוע",
      celebrantDetails: "פרטי החוגגים",
      servicesAndApprovals: "שירותים ואישורים",
      payment: "תשלום",
    },

    // Fields
    fields: {
      fullName: "שם מלא",
      phone: "טלפון",
      email: "אימייל",
      eventDate: "תאריך האירוע",
      receptionTime: "שעת קבלת פנים",
      venue: "מקום האירוע",
      address: "כתובת",
      eventName: "שם האירוע",
      specialRequests: "בקשות מיוחדות והערות",
      creditCard: "מספר כרטיס אשראי",
      cardHolderId: "תעודת זהות בעל הכרטיס",
      cardHolderName: "שם בעל הכרטיס",
      cardExpiry: "תוקף כרטיס",
      cardCvv: "3 ספרות אחרונות בגב הכרטיס",
      coupleName1: "שם בן/בת הזוג הראשון",
      couplePhone1: "טלפון (בן/בת זוג, אופציונלי)",
      couple1Parent1: "שם הורה 1 (אופציונלי)",
      couple1Parent2: "שם הורה 2 (אופציונלי)",
      coupleName2: "שם בן/בת הזוג השני",
      couplePhone2: "טלפון (בן/בת זוג, אופציונלי)",
      couple2Parent1: "שם הורה 1 (אופציונלי)",
      couple2Parent2: "שם הורה 2 (אופציונלי)",
      mitzvahType: "סוג האירוע",
      barMitzvah: "בר מצווה",
      batMitzvah: "בת מצווה",
      childNameBar: "שם הנער",
      childNameBat: "שם הנערה",
      childName: "שם הילד/ה",
      parentDetails: "פרטי ההורים (לפחות אחד נדרש)",
      parent1Name: "שם הורה 1",
      parent1Phone: "טלפון הורה 1 (אופציונלי)",
      parent2Name: "שם הורה 2 (אופציונלי)",
      parent2Phone: "טלפון הורה 2 (אופציונלי)",
      britType: "סוג האירוע",
      britMilah: "ברית",
      britBat: "בריתה",
      childNameBritBoy: "שם התינוק",
      childNameBritGirl: "שם התינוקת",
      giftService: "שירות מתנות באשראי",
      termsAndConditions: "תקנון השירות",
      agreeToTerms: "אני מאשר/ת שקראתי את",
      termsLink: "תקנון השירות",
      agreeToGiftTerms: "אני מאשר/ת שקראתי את",
      giftTermsLink: "תקנון שירות המתנות",
      securityDetails:
        "פרטי האשראי לא נשמרים אצלנו, אלא מאובטחים בחברת הסליקה שמוסמכת לעמוד בתקני האבטחה המחמירים ביותר (PCI DSS). בנוסף, גם אנחנו עומדים בתקני ISO לאבטחת מידע, כך שאפשר להיות בטוחים שהנושא הזה נמצא אצלנו בראש סדר העדיפויות, במיוחד כשמדובר במידע רגיש כזה 🙏",
      seatingServiceTitle: "סידורי הושבה מבית WiWi",
      seatingServiceSubtitle:
        "באירועים מעל 400 מגיעים, נדרש דייל נוסף בתוספת 400 ₪",
      howItWorks: "איך זה עובד?",
      seatingDesc1:
        "שבוע לפני האירוע, מסיימים עם האישורי הגעה ומקבלים קישור למערכת ההושבה הדיגיטלית. שם מושיבים את כל האורחים בשולחנות.",
      seatingDesc2:
        "ביום האירוע נשלחות הודעות WhatsApp עם מספרי שולחן לאורחים.",
      seatingDesc3: "2 אנשי צוות מנוסים מגיעים לאולם לפני קבלת הפנים.",
      whatDoTheyDo: "מה הדיילים עושים?",
      seatingDuties1: "מקימים עמדות קבלה אטרקטיביות בכניסה לאולם",
      seatingDuties2: "פתקי הושבה וחלוקת פתקים לאורחים עם מספרי השולחנות",
      seatingDuties3:
        "רישום ותיעוד של האורחים שהגיעו בפועל ועדכון הזוג ביום למחרת עם דוח מסודר ומפורט",
      seatingDuties4:
        "סידור הכיסאות בהתאם לכמות האנשים שהגיעו במהלך הכניסה של האורחים לחופה",
      seatingDuties5:
        "הכוונת האורחים לשולחנות לאחר החופה על ידי דיילות ייצוגיות שיעמדו בכניסה לאולם",
      seatingDuties6: "צמצום מקומות ישיבה (חורים) בתוך האולם",
      seatingDuties7: "מניעת פתיחת שולחנות רזרבה שלא לצורך",
      seatingDuties8:
        "מוודאים עם מנהל האירוע איפה כל האורחים יושבים ולא הולכים לשום מקום עד שלכל אורח יש מקום ישיבה",
      interestedInSeating: "האם תרצו לקבל פרטים נוספים על השירות?",
      yesInterested: "כן, אני מעוניין/ת לשמוע פרטים",
      noThanks: "לא, תודה",
    },

    // Placeholders
    placeholders: {
      enterFullName: "שם מלא",
      phoneNumber: "05X-XXXXXXX",
      email: "example@email.com",
      selectDate: "בחרו תאריך",
      time: "20:30",
      timeEstimation: "אפשר למלא שעה משוערת, ניתן לערוך בהמשך.",
      venueName: "שם האולם או הכתובת",
      enterAddress: "הכנס כתובת",
      specialRequests: "כל מה שחשוב לכם שנדע...",
      creditCard: "0000 0000 0000 0000",
      idNumber: "123456789",
      fullNameOnCard: "שם מלא כפי שמופיע על הכרטיס",
      cardExpiry: "MM/YY",
      cvv: "123",
      childNameDefault: "הילד/ה",
      childNameMitzvahDefault: "הנער/ה",
      babyNameDefault: "התינוק/ת",
      coupleNameDefault: "חתן/כלה",
      familyNameDefault: "ישראל",
      eventNameDefault: "יווצר אוטומטית עם מילוי הפרטים הרלוונטיים...",
    },

    // Buttons
    buttons: {
      next: "הבא",
      back: "חזור",
      submit: "שלח טופס רישום",
      sendOtp: "המשך",
      verifyOtp: "אשר קוד",
      downloadPdf: "הורדת PDF",
      newRegistration: "רישום נוסף",
      close: "סגור",
      yes: "כן, אני רוצה להפעיל",
      no: "לא, תודה",
      continueToSummary: "המשך לסיכום",
      editEventName: "עריכה ידנית",
      cancelEdit: "ביטול עריכה",
      changeEventType: "שנה סוג אירוע",
    },

    // Messages
    messages: {
      phoneVerified: "מספר הטלפון אומת מראש",
      phoneVerificationNeeded: "יש לאמת את מספר הטלפון על מנת להמשיך.",
      otpSent: "שלחנו קוד אימות למספר",
      enterCode: "אנא הזן את הקוד שקיבלת",
      submissionSuccess: "הרישום נשלח בהצלחה!",
      thankYou: "תודה שבחרת ב-WiWi. נחזור אליך בקרוב עם כל הפרטים.",
      canDownloadPdf: "ניתן להוריד עותק של טופס הרישום כקובץ PDF.",
      otpInvalid: "הקוד שהוזן אינו תקין. נסה שנית.",
      otpVerifying: "מאמת...",
      otpSending: "שולח...",
      stepOfTotal: (current, total) => `שלב ${current} מתוך ${total}`,

      // Validation messages
      required: (field) => `${field} חובה`,
      invalidPhone: "מספר טלפון לא תקין (נדרש 10 ספרות)",
      invalidEmail: "כתובת אימייל לא תקינה",
      atLeastOneParent: "נדרש לפחות שם הורה אחד",
      invalidCreditCard: "מספר כרטיס אשראי לא תקין",
      invalidID: "תעודת זהות לא תקינה (9 ספרות)",
      invalidCardExpiry: "תוקף כרטיס לא תקין (MM/YY)",
      invalidCvv: "CVV לא תקין (3 ספרות)",
      submitting: "שולח...",
    },

    // Package details
    package: {
      title: "סיכום עסקה - חבילת יוני 2026",
      deposit: "מקדמה",
      pricePerRecord: "מחיר לרשומה מוצלחת",
      giftService: "שירות מתנות באשראי",
      depositAmount: "200 ₪",
      recordPrice: "1.80 ₪ (במקום 2.00 ₪)",
      giftPrice: "159 ₪ (במקום 200 ₪)",
      depositNote: "* יקוזז מהתשלום הסופי",
      successfulRecord: "רשומה מוצלחת",
      successfulRecordDesc:
        'רשומה (מספר טלפון) שממנה התקבלה תשובה בפועל – "מגיע", "לא מגיע" או "מתלבט" – כלומר, רשומה שהצלחנו להביא לכם תשובה לגביה. התשלום הסופי יתבצע רק לפי מספר הרשומות המוצלחות.',
    },
    packageUnavailable: {
      title: "החבילה אינה זמינה",
      message1: "מצטערים, חבילת יוני 2026 אינה זמינה יותר או פג תוקפה.",
      message2: "אנא צרו קשר עם צוות WiWi למידע על חבילות זמינות אחרות.",
      contactInfo: "פרטי יצירת קשר",
      backToWebsite: "חזור לאתר WiWi",
    },
    // Final Summary Screen
    finalSummary: {
      title: "רישום הושלם בהצלחה!",
      subtitle: "תודה שבחרת ב-WiWi! להלן כל המידע שתצטרך:",
      downloadDealSummary: "הורדת סיכום עסקה",
      downloadInvoice: "הורדת חשבונית",
      watchTutorial: "צפייה בהדרכה",
      customerServiceWhatsapp: "שירות לקוחות בוואטסאפ",
      interestedInReferral: "כן, אני מעוניין!",
      referralNamePlaceholder: "שם החבר/ה",
      referralPhonePlaceholder: "מספר טלפון של החבר/ה",
      referralTitle: "הפנו חבר וקבלו 10 רשומות חינם!",
      referralDescription:
        "יש לכם חבר/ה שחוגג/ת אירוע בקרוב? רשמו את המספר שלו/ה ואם ירשם לשירות - תקבלו 10 רשומות ללא עלות!",
      referralPlaceholder: "מספר טלפון של החבר/ה",
      sendReferral: "שלח הפניה",
      referralSuccess: "תודה! נעדכן אותך ברגע שחברך ירשם",
      addFriend: "הוסף חבר נוסף",
      referralDisclaimer:
        'אני מאשר/ת שהפרטים שנמסרו הינם נכונים, והחברים המומלצים מתכננים אירוע בקרוב. אני מבין/ה שההטבה תינתן רק לאחר שהחבר יסגור אירוע עם החברה. כמו כן, אני מאשר/ת כי החבר נתן את הסכמתו להעברת פרטיו לצורך יצירת קשר בנושא ההמלצה. אני גם מבין/ה שאם החבר פנה ל-WiWi באמצעים אחרים לפני ההמלצה שלי, הוא לא יהיה זכאי להטבה ולא ייחשב כמי שהגיע דרך ההטבה "חבר מביא חבר", כאשר הרישום הקובע הוא במערכות החברה.',
    },
    invoices: {
      1: "חיובי אירוע",
      2: "הפעלת מתנות",
      3: "אחרים",
      4: "מקדמה תבנית",
      5: "מקדמה הובלה",
      6: "תשלום מראש",
      7: "דחייה",
      8: "החזר חיוב",
      9: "אורחים חינם",
      10: "מימיקס",
      11: "יצירת אירוע",
    },
  },
  en: {
    // General
    appTitle: "WiWi Service Registration Form",
    appSubtitle:
      "Fill in the details and we'll create an unforgettable event experience for you.",
    errorOccured: "An error occurred. Please try again.",
    // Event types
    eventTypeSelectionTitle: "Choose Your Event Type",
    eventTypeSelectionSubtitle:
      "This selection will help us customize the form for you.",
    eventTypes: {
      wedding: "Wedding",
      henna: "Henna",
      bar_bat_mitzvah: "Bar/Bat Mitzvah",
      brit: "Brit Milah/Bat",
    },

    // Form steps
    formSteps: {
      clientDetails: "Client Details",
      eventDetails: "Event Details",
      celebrantDetails: "Celebrant Details",
      servicesAndApprovals: "Services & Approvals",
      payment: "Payment",
    },

    // Fields
    fields: {
      fullName: "Full Name",
      phone: "Phone",
      email: "Email",
      eventDate: "Event Date",
      receptionTime: "Reception Time",
      venue: "Venue",
      address: "Address",
      eventName: "Event Name",
      specialRequests: "Special Requests & Notes",
      creditCard: "Credit Card Number",
      cardHolderId: "Card Holder ID",
      cardHolderName: "Card Holder Name",
      cardExpiry: "Card Expiry",
      cardCvv: "CVV (3 digits on back)",
      coupleName1: "First Couple's Name",
      couplePhone1: "Couple's Phone (Optional)",
      couple1Parent1: "Parent 1 Name (Optional)",
      couple1Parent2: "Parent 2 Name (Optional)",
      coupleName2: "Second Couple's Name",
      couplePhone2: "Couple's Phone (Optional)",
      couple2Parent1: "Parent 1 Name (Optional)",
      couple2Parent2: "Parent 2 Name (Optional)",
      mitzvahType: "Event Type",
      barMitzvah: "Bar Mitzvah",
      batMitzvah: "Bat Mitzvah",
      childNameBar: "Boy's Name",
      childNameBat: "Girl's Name",
      childName: "Child's Name",
      parentDetails: "Parents' Details (at least one required)",
      parent1Name: "Parent 1 Name",
      parent1Phone: "Parent 1 Phone (Optional)",
      parent2Name: "Parent 2 Name (Optional)",
      parent2Phone: "Parent 2 Phone (Optional)",
      britType: "Event Type",
      britMilah: "Brit Milah",
      britBat: "Brit Bat",
      childNameBritBoy: "Baby Boy's Name",
      childNameBritGirl: "Baby Girl's Name",
      giftService: "Credit Card Gift Service",
      termsAndConditions: "Service Terms & Conditions",
      agreeToTerms: "I confirm that I have read the",
      termsLink: "Service Terms and Conditions",
      agreeToGiftTerms: "I confirm that I have read the",
      giftTermsLink: "Gift Service Terms and Conditions",
      securityDetails:
        "Credit card details are not stored with us, but are secured by the clearing company which is certified to meet the strictest security standards (PCI DSS). In addition, we also meet ISO information security standards, so you can be sure that this issue is our top priority, especially when it comes to such sensitive information 🙏",
      seatingServiceTitle: "WiWi Seating Arrangements",
      seatingServiceSubtitle:
        "For events with over 400 guests, an additional usher is required at an extra cost of ₪400.",
      howItWorks: "How it works?",
      seatingDesc1:
        "One week before the event, guest confirmations are finalized, and you receive a link to the digital seating system. There, all guests are assigned to tables.",
      seatingDesc2:
        "On the day of the event, WhatsApp messages are sent to guests with their table numbers.",
      seatingDesc3:
        "Two experienced staff members arrive at the venue before the reception.",
      whatDoTheyDo: "What do the ushers do?",
      seatingDuties1:
        "Set up attractive reception stands at the entrance to the hall",
      seatingDuties2:
        "Prepare seating cards and distribute them to guests with table numbers",
      seatingDuties3:
        "Register and document guests who actually arrived and update the couple the next day with an organized and detailed report",
      seatingDuties4:
        "Arrange chairs according to the number of people who arrived during guests' entry to the chuppah",
      seatingDuties5:
        "Direct guests to tables after the chuppah by representative ushers who will stand at the entrance to the hall",
      seatingDuties6: "Reduce empty seats (gaps) within the hall",
      seatingDuties7: "Prevent unnecessary opening of reserve tables",
      seatingDuties8:
        "Confirm with the event manager where all guests are seated and do not leave until every guest has a seat",
      interestedInSeating:
        "Would you like to receive more details about this service?",
      yesInterested: "Yes, I am interested in hearing more details",
      noThanks: "No, thank you",
    },

    // Placeholders
    placeholders: {
      enterFullName: "Enter your full name",
      phoneNumber: "05X-XXXXXXX",
      email: "example@email.com",
      selectDate: "Select date",
      time: "20:30",
      timeEstimation: "You can enter an estimated time, editable later.",
      venueName: "Hall name or address",
      enterAddress: "Enter address",
      specialRequests: "Anything important for us to know...",
      creditCard: "0000 0000 0000 0000",
      idNumber: "123456789",
      fullNameOnCard: "Full name as it appears on the card",
      cardExpiry: "MM/YY",
      cvv: "123",
      childNameDefault: "Child",
      childNameMitzvahDefault: "Youth",
      babyNameDefault: "Baby",
      coupleNameDefault: "Bride/Groom",
      familyNameDefault: "Family",
      eventNameDefault:
        "Will be automatically generated upon filling in relevant details...",
    },

    // Buttons
    buttons: {
      next: "Next",
      back: "Back",
      submit: "Submit Registration Form",
      sendOtp: "Verify Number",
      verifyOtp: "Verify Code",
      downloadPdf: "Download PDF",
      newRegistration: "New Registration",
      close: "Close",
      yes: "Yes, I want to activate",
      no: "No, thank you",
      continueToSummary: "Continue to Summary",
      editEventName: "Manual Edit",
      cancelEdit: "Cancel Edit",
      changeEventType: "Change Event Type",
    },

    // Messages
    messages: {
      phoneVerified: "Phone number pre-verified",
      phoneVerificationNeeded:
        "Phone number verification required to continue.",
      otpSent: "We sent a verification code to",
      enterCode: "Please enter the code (for demo: ",
      submissionSuccess: "Registration submitted successfully!",
      thankYou:
        "Thank you for choosing WiWi. We'll get back to you soon with all the details.",
      canDownloadPdf:
        "You can download a copy of the registration form as a PDF file.",
      otpInvalid: "The code entered is invalid. Please try again.",
      otpVerifying: "Verifying...",
      otpSending: "Sending...",
      submitting: "Submitting...",
      stepOfTotal: (current, total) => `Step ${current} of ${total}`,

      // Validation messages
      required: (field) => `${field} is required`,
      invalidPhone: "Invalid phone number (10 digits required)",
      invalidEmail: "Invalid email address",
      atLeastOneParent: "At least one parent's name is required",
      invalidCreditCard: "Invalid credit card number",
      invalidID: "Invalid ID (9 digits)",
      invalidCardExpiry: "Invalid card expiry (MM/YY)",
      invalidCvv: "Invalid CVV (3 digits)",
    },

    // Package details
    package: {
      title: "Deal Summary - June 2026 Package",
      deposit: "Deposit",
      pricePerRecord: "Price per successful record",
      giftService: "Credit Card Gift Service",
      depositAmount: "₪200",
      recordPrice: "₪1.80 (instead of ₪2.00)",
      giftPrice: "₪159 (instead of ₪200)",
      depositNote: "* Will be deducted from final payment",
      successfulRecord: "Successful record",
      successfulRecordDesc:
        "Guest we invited and received a response from (confirmation or decline). Final payment will be based on successful records only.",
    },
    packageUnavailable: {
      title: "Package Unavailable",
      message1:
        "Sorry, the June 2026 package is no longer available or has expired.",
      message2:
        "Please contact the WiWi team for information about other available packages.",
      contactInfo: "Contact Information",
      backToWebsite: "Back to WiWi Website",
    },
    // Final Summary Screen
    finalSummary: {
      title: "Registration Completed Successfully!",
      subtitle:
        "Thank you for choosing WiWi! Here is all the information you need:",
      downloadDealSummary: "Download Deal Summary",
      downloadInvoice: "Download Invoice",
      watchTutorial: "Watch Tutorial",
      customerServiceWhatsapp: "Customer Service WhatsApp",
      referralTitle: "Refer a Friend & Get 10 Free Records!",
      referralDescription:
        "Do you have a friend celebrating an event soon? Enter their details and if they register - you'll get 10 free records!",
      interestedInReferral: "Yes, I'm interested in referring a friend",
      referralNamePlaceholder: "Friend's name",
      referralPhonePlaceholder: "Friend's phone number",
      sendReferral: "Send Referral",
      addFriend: "Add Another Friend",
      referralSuccess: "Thanks! We'll update you once your friends register",
      referralDisclaimer:
        'I confirm that the details provided are correct, and the recommended friend is planning an event soon. I understand that the benefit will only be given after the friend closes an event with the company. I also confirm that the friend has given consent to transfer their details for contact regarding the referral. I also understand that if the friend contacted WiWi through other means before my referral, they will not be eligible for the benefit and will not be considered as someone who came through the "friend brings friend" benefit, where the determining registration is in the company\'s systems.',
    },
    invoices: {
      1: "Event Charges",
      2: "Gift Activation",
      3: "Others",
      4: "Advance Template",
      5: "Advance Transport",
      6: "Prepaid",
      7: "Postpone",
      8: "Charge Back",
      9: "Free Guests",
      10: "Mimix",
      11: "Event Creation",
    },
  },
};

const STAGES = {
  SELECT_EVENT_TYPE: "select_event_type",
  FILL_DETAILS: "fill_details",
  SEATING_SERVICE: "seating_service",
  PACKAGE_UNAVAILABLE: "package_unavailable", // New stage
};

const initialFormData = {
  event_type: "",
  mitzvah_type: "",
  brit_type: "",
  event_name: "",
  client_name: "",
  client_phone: "",
  client_email: "",
  credit_card_number: "",
  card_holder_id: "",
  card_holder_name: "",
  card_expiry: "",
  card_cvv: "",
  event_date: null,
  reception_time: "",
  venue: "",
  address: "",
  couple_name_1: "",
  couple_phone_1: "",
  couple1_parent1_name: "",
  couple1_parent2_name: "",
  couple_name_2: "",
  couple_phone_2: "",
  couple2_parent1_name: "",
  couple2_parent2_name: "",
  child_name: "",
  parent1_name: "",
  parent1_phone: "",
  parent2_name: "",
  parent2_phone: "",
  activate_gift_service: null,
  want_seating_service: null,
  terms_agreed: false,
  gift_terms_agreed: false,
  special_requests: "",
};

//const OTP_CODE = "123456";

const eventTypes = {
  wedding: {
    id: 1,
    label: translations.he.eventTypes.wedding,
    labelEn: translations.en.eventTypes.wedding,
    icon: Heart,
    internalValue: "wedding",
  },
  henna: {
    id: 2,
    label: translations.he.eventTypes.henna,
    labelEn: translations.en.eventTypes.henna,
    icon: Sparkles,
    internalValue: "henna",
  },
  bar_bat_mitzvah: {
    id: 3,
    label: translations.he.eventTypes.bar_bat_mitzvah,
    labelEn: translations.en.eventTypes.bar_bat_mitzvah,
    icon: Award,
    internalValue: "bar_bat_mitzvah",
  },
  brit: {
    id: 4,
    label: translations.he.eventTypes.brit,
    labelEn: translations.en.eventTypes.brit,
    icon: Baby,
    internalValue: "brit",
  },
};

const QUICK_REG_MIN_EVENT_DATE_DAYS_AHEAD = 3;

function calculateMinimumQuickRegEventDate(
  fromDate = new Date(),
  daysAhead = QUICK_REG_MIN_EVENT_DATE_DAYS_AHEAD,
) {
  let date = startOfDay(fromDate);
  let counted = 0;

  while (counted < daysAhead) {
    date = addDays(date, 1);
    const day = date.getDay();
    if (day !== 5 && day !== 6) {
      counted++;
    }
  }

  return date;
}

export default function RegistrationPage({ shortLink }) {
  const { packageHash } = useParams();
  const navigate = useNavigate();
  const [currentStage, setCurrentStage] = useState(STAGES.SELECT_EVENT_TYPE);
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [isEditingEventName, setIsEditingEventName] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [packageDetails, setPackageDetails] = useState(null);

  // State for URL params and OTP
  const [isEventTypeFromUrl, setIsEventTypeFromUrl] = useState(false);
  const [isPhoneFromUrl, setIsPhoneFromUrl] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("he");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [expiryPageData, setExpiryPageData] = useState({
    show: false,
    extendable: false,
  });

  const [invoices, setInvoices] = useState([]);
  const eventTypeDetail = useMemo(() => {
    const id = eventTypes[formData.event_type]?.id;
    if (id && packageDetails) {
      var index = packageDetails.event_types.find(
        (i) => i.event_type_id === id,
      );
      if (index) return index;
    }
    return null;
  }, [formData.event_type, packageDetails]);

  const [formStep, setFormStep] = useState(0);
  const [animationDirection, setAnimationDirection] = useState(1);

  // New state for referral in final summary
  const [referralFriends, setReferralFriends] = useState([
    { name: "", phone: "" },
  ]);
  const [referralSubmitted, setReferralSubmitted] = useState(false);
  const [referralTermsAgreed, setReferralTermsAgreed] = useState(false);
  const [showReferralForm, setShowReferralForm] = useState(false);
  const [isSubmittingReferral, setIsSubmittingReferral] = useState(false);

  // DEV MODE - for development purposes
  const [devMode, setDevMode] = useState(false);

  // Get current translations
  const t = translations[currentLanguage] || translations.he;
  const isRTL = currentLanguage === "he";
  const dateLocale = isRTL ? he : enUS;

  // Dynamic form steps based on language
  const formSteps = [
    { id: 1, name: t.formSteps.clientDetails },
    { id: 2, name: t.formSteps.eventDetails },
    { id: 3, name: t.formSteps.celebrantDetails },
    { id: 4, name: t.formSteps.servicesAndApprovals },
    { id: 5, name: t.formSteps.payment },
  ];

  async function fetchPackage() {
    try {
      const res = await api.get(
        shortLink
          ? `/GetPackage?token=${packageHash}`
          : `/Package?token=${packageHash}`,
      );
      if (res.data.success) {
        Bugsnag.setUser(
          packageHash,
          "",
          shortLink ? "ShortLinkUser" : "RegularUser",
        );
        const d = { ...res.data.data };
        setPackageDetails(d);
        if (d.phone) {
          setFormData({
            ...initialFormData,
            client_phone: d.phone.startsWith("972")
              ? `0${d.phone.substring(3)}`
              : d.phone,
          });
          setIsPhoneFromUrl(true);
          setIsPhoneVerified(true);
        }
        return;
      } else if (res.data.errorCode === 1064) {
        setExpiryPageData({ show: true, extendable: res.data.data.extendable });
        return;
      }
      navigate("/PackageUnavailable");
    } catch (error) {
      console.error("Error fetching package:", error);
      navigate("/PackageUnavailable");
      throw error;
    }
  }

  useEffect(() => {
    if (packageHash) fetchPackage();
    else navigate("/PackageUnavailable");
  }, [packageHash]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const eventTypeParam = urlParams.get("event_type");
    // const clientPhoneParam = urlParams.get("client_phone");
    // const encodedPhoneParam = urlParams.get("p");
    const languageParam = urlParams.get("language");
    const packageExpiredParam = urlParams.get("expired");

    // DEV MODE parameters
    const devModeParam = import.meta.env.DEV ? urlParams.get("dev_mode") : null;
    const skipToParam = import.meta.env.DEV ? urlParams.get("skip_to") : null; // Options: 'summary', 'seating', 'form', 'package_unavailable'

    let initialPhonePreFilledFromUrl = false;
    let initialFormDataState = { ...initialFormData };
    let initialCurrentStage = STAGES.SELECT_EVENT_TYPE;
    let initialIsSubmitted = false;
    let initialSubmittedData = null;
    let initialIsEventTypeFromUrl = false;
    let initialIsPhoneFromUrl = false;
    let initialIsPhoneVerified = false;

    // 1. Handle language parameter first
    if (languageParam && (languageParam === "en" || languageParam === "he")) {
      setCurrentLanguage(languageParam);
    }

    // 2. Handle Dev Mode and Skip To
    if (import.meta.env.DEV && devModeParam === "true") {
      setDevMode(true);
      // console.log("🔧 DEV MODE ENABLED");
      // console.log(
      //   "Available skip_to options: 'summary', 'seating', 'form', 'package_unavailable'"
      // );

      if (skipToParam) {
        // Pre-fill form with dummy data for dev
        initialFormDataState = {
          ...initialFormDataState,
          event_type: "wedding", // Default event type for dev mode prefill
          client_name: "ישראל ישראלי",
          client_phone: "0501234567",
          client_email: "test@example.com",
          event_date: new Date(2026, 5, 15),
          reception_time: "18:00",
          venue: "אולם החלומות",
          couple_name_1: "חתן לדוגמה",
          couple_name_2: "כלה לדוגמה",
          activate_gift_service: true,
          want_seating_service: false,
          terms_agreed: true,
          gift_terms_agreed: true,
          credit_card_number: "1234 5678 9012 3456",
          card_holder_id: "123456789",
          card_holder_name: "ישראל ישראלי",
          card_expiry: "12/28",
          card_cvv: "123",
        };
        initialIsPhoneVerified = true;
        initialIsPhoneFromUrl = true;
        initialIsEventTypeFromUrl = true; // Assume event type is set for dev prefill

        switch (skipToParam) {
          case "summary":
            initialIsSubmitted = true;
            initialSubmittedData = initialFormDataState;
            // For summary, still need a stage set for background logic, but `isSubmitted` will control UI.
            initialCurrentStage = STAGES.FILL_DETAILS;
            break;
          case "seating":
            initialCurrentStage = STAGES.SEATING_SERVICE;
            break;
          case "form":
            initialCurrentStage = STAGES.FILL_DETAILS;
            setFormStep(0);
            break;
          case "package_unavailable":
            initialCurrentStage = STAGES.PACKAGE_UNAVAILABLE;
            break;
          default:
            // If invalid skip_to, proceed to normal flow if no other params, or default to form.
            initialCurrentStage = STAGES.FILL_DETAILS;
            break;
        }
        // Update states and return early, as dev mode has set everything
        setFormData(initialFormDataState);
        setIsPhoneVerified(initialIsPhoneVerified);
        setIsPhoneFromUrl(initialIsPhoneFromUrl);
        setIsEventTypeFromUrl(initialIsEventTypeFromUrl);
        setIsSubmitted(initialIsSubmitted);
        setSubmittedData(initialSubmittedData);
        setCurrentStage(initialCurrentStage);
        return; // Critical: exit early after dev mode initialization
      }
    }

    // 3. Handle package expired (if not overridden by dev mode)
    if (packageExpiredParam === "true") {
      setCurrentStage(STAGES.PACKAGE_UNAVAILABLE);
      return; // Exit early
    }

    // 4. Normal URL parameter processing (if not already handled by dev mode)

    // Handle event type parameter
    if (
      eventTypeParam &&
      Object.values(eventTypes).find(
        (et) => et.internalValue === eventTypeParam,
      )
    ) {
      initialFormDataState.event_type = eventTypeParam;
      initialIsEventTypeFromUrl = true;
      initialCurrentStage = STAGES.FILL_DETAILS;
    }

    // Handle phone parameters - Prioritize encoded, then plain text

    // if (encodedPhoneParam) {
    //   try {
    //     const decodedPhone = atob(encodedPhoneParam);
    //     if (/^\d{10}$/.test(decodedPhone)) {
    //       initialFormDataState.client_phone = decodedPhone;
    //       initialPhonePreFilledFromUrl = true;
    //       // console.log("Phone decoded from 'p' parameter and pre-filled.");
    //     } else {
    //       console.warn(
    //         "Decoded phone from 'p' parameter is not a 10-digit number. Skipping pre-fill."
    //       );
    //     }
    //   } catch (e) {
    //     console.error(
    //       "Failed to decode 'p' parameter. It might not be a valid Base64 string.",
    //       e
    //     );
    //   }
    // } else if (clientPhoneParam) {
    //   if (/^\d{10}$/.test(clientPhoneParam.replace(/[^0-9]/g, ""))) {
    //     initialFormDataState.client_phone = clientPhoneParam;
    //     initialPhonePreFilledFromUrl = true;
    //   } else {
    //     console.warn(
    //       "Client phone from 'client_phone' parameter is not a 10-digit number. Skipping pre-fill."
    //     );
    //   }
    // }

    initialIsPhoneVerified = initialPhonePreFilledFromUrl;
    initialIsPhoneFromUrl = initialPhonePreFilledFromUrl;

    // Apply initial states if not already set by dev mode.
    setFormData(initialFormDataState);
    setIsEventTypeFromUrl(initialIsEventTypeFromUrl);
    setCurrentStage(initialCurrentStage);
    setIsPhoneVerified(initialIsPhoneVerified);
    setIsPhoneFromUrl(initialIsPhoneFromUrl);
  }, []); // Empty dependency array, runs only once on mount. All initial state logic is here.

  const generateEventName = useCallback(() => {
    if (!formData || !formData.event_type) return "";

    const {
      event_type,
      client_name,
      couple_name_1,
      couple_name_2,
      child_name,
      parent1_name,
      parent2_name,
      mitzvah_type,
      brit_type,
    } = formData;

    if (currentLanguage === "en") {
      switch (event_type) {
        case "wedding":
          return `Wedding of ${
            couple_name_1 || t.placeholders.coupleNameDefault
          } and ${couple_name_2 || t.placeholders.coupleNameDefault}`;
        case "henna":
          return `Henna of ${
            couple_name_1 || t.placeholders.coupleNameDefault
          } and ${couple_name_2 || t.placeholders.coupleNameDefault}`;
        case "bar_bat_mitzvah": {
          const mitzvahLabelEn =
            mitzvah_type === "bar"
              ? "Bar Mitzvah"
              : mitzvah_type === "bat"
                ? "Bat Mitzvah"
                : "Bar/Bat Mitzvah";
          return `${mitzvahLabelEn} of ${
            child_name || t.placeholders.childNameMitzvahDefault
          }`;
        }
        case "brit": {
          const britLabelEn =
            brit_type === "boy"
              ? "Brit Milah"
              : brit_type === "girl"
                ? "Brit Bat"
                : "Brit";
          return `${britLabelEn} of ${
            child_name || t.placeholders.babyNameDefault
          } - ${
            parent1_name ||
            parent2_name ||
            client_name ||
            t.placeholders.familyNameDefault
          } Family`;
        }
        default:
          return "";
      }
    } else {
      switch (event_type) {
        case "wedding":
          return `חתונה של ${
            couple_name_1 || t.placeholders.coupleNameDefault
          } ו${couple_name_2 || t.placeholders.coupleNameDefault}`;
        case "henna":
          return `חינה של ${
            couple_name_1 || t.placeholders.coupleNameDefault
          } ו${couple_name_2 || t.placeholders.coupleNameDefault}`;
        case "bar_bat_mitzvah": {
          const mitzvahLabel =
            mitzvah_type === "bar"
              ? t.fields.barMitzvah
              : mitzvah_type === "bat"
                ? t.fields.batMitzvah
                : t.eventTypes.bar_bat_mitzvah;
          return `${mitzvahLabel} של ${
            child_name || t.placeholders.childNameMitzvahDefault
          }`;
        }
        case "brit": {
          // Fix for parsing error: changed 'girl' to "girl" to avoid unescaped apostrophe issue
          const britLabel =
            brit_type === "boy"
              ? t.fields.britMilah
              : brit_type === "girl"
                ? t.fields.britBat
                : t.eventTypes.brit;
          return `${britLabel} של ${
            child_name || t.placeholders.babyNameDefault
          } למשפחת ${
            parent1_name ||
            parent2_name ||
            client_name ||
            t.placeholders.familyNameDefault
          }`;
        }
        default:
          return "";
      }
    }
  }, [formData, currentLanguage, t]);

  useEffect(() => {
    if (
      currentStage === STAGES.FILL_DETAILS &&
      !isEditingEventName &&
      formData.event_type
    ) {
      const eventName = generateEventName();
      // Only update if the event name actually changed to prevent loops
      setFormData((prev) => {
        if (prev.event_name !== eventName) {
          return { ...prev, event_name: eventName };
        }
        return prev;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentStage,
    isEditingEventName,
    formData.event_type,
    formData.client_name,
    formData.couple_name_1,
    formData.couple_name_2,
    formData.child_name,
    formData.parent1_name,
    formData.parent2_name,
    formData.mitzvah_type,
    formData.brit_type,
    currentLanguage,
    t,
  ]);

  const validateStep = (step) => {
    const newErrors = { ...errors };

    const clearError = (field) => {
      if (newErrors[field]) delete newErrors[field];
    };

    if (step === 0) {
      // Client Details
      if (!formData.client_name.trim()) {
        newErrors.client_name = t.messages.required(t.fields.fullName);
      } else if (formData.client_name.trim().split(/\s+/).length < 2) {
        newErrors.client_name = isRTL
          ? "נדרש שם פרטי ושם משפחה"
          : "First and last name required";
      } else {
        clearError("client_name");
      }

      if (!formData.client_phone.trim()) {
        newErrors.client_phone = t.messages.required(t.fields.phone);
      } else {
        const cleanPhone = formData.client_phone.replace(/[^0-9]/g, "");
        if (
          !/^05\d{8}$/.test(cleanPhone) &&
          !isInternationalPhoneNumber(cleanPhone)
        ) {
          newErrors.client_phone = isRTL
            ? "מספר טלפון לא תקין"
            : "Invalid phone number";
        } else {
          clearError("client_phone");
        }
      }

      //   if (
      //     !isPhoneFromUrl &&
      //     !isPhoneVerified &&
      //     formData.client_phone.length > 0 &&
      //     /^\d{10}$/.test(formData.client_phone.replace(/[^0-9]/g, ""))
      //   ) {
      //     newErrors.client_phone_otp = t.messages.phoneVerificationNeeded;
      //   } else {
      //     clearError("client_phone_otp");
      //   }

      if (!formData.client_email.trim()) {
        newErrors.client_email = t.messages.required(t.fields.email);
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.client_email)) {
        newErrors.client_email = t.messages.invalidEmail;
      } else {
        clearError("client_email");
      }
    }

    if (step === 1) {
      // Event Details
      if (!formData.event_date)
        newErrors.event_date = t.messages.required(t.fields.eventDate);
      else clearError("event_date");
      if (!formData.reception_time.trim()) {
        newErrors.reception_time = t.messages.required(t.fields.receptionTime);
      } else if (
        !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(formData.reception_time)
      ) {
        newErrors.reception_time = isRTL
          ? "יש להזין שעה בפורמט 24 שעות (לדוגמה: 20:30)"
          : "Please enter time in 24-hour format (e.g., 20:30)";
      } else {
        clearError("reception_time");
      }
      if (!formData.venue.trim())
        newErrors.venue = t.messages.required(t.fields.venue);
      else clearError("venue");

      if (!formData.address || !formData.address.trim())
        newErrors.address = t.messages.required(t.fields.address);
      else clearError("address");
    }

    if (step === 2) {
      // Celebrant Details
      if (
        formData.event_type === "wedding" ||
        formData.event_type === "henna"
      ) {
        if (!formData.couple_name_1.trim())
          newErrors.couple_name_1 = t.messages.required(t.fields.coupleName1);
        else clearError("couple_name_1");
        if (!formData.couple_name_2.trim())
          newErrors.couple_name_2 = t.messages.required(t.fields.coupleName2);
        else clearError("couple_name_2");
        if (formData.couple_phone_1 !== "") {
          const cleanPhone = formData.couple_phone_1.replace(/[^0-9]/g, "");
          if (
            !/^05\d{8}$/.test(cleanPhone) &&
            !isInternationalPhoneNumber(cleanPhone)
          ) {
            newErrors.couple_phone_1 = isRTL
              ? "מספר טלפון לא תקין"
              : "Invalid phone number";
          } else {
            clearError("couple_phone_1");
          }
        }
        if (formData.couple_phone_2 !== "") {
          const cleanPhone = formData.couple_phone_2.replace(/[^0-9]/g, "");
          if (
            !/^05\d{8}$/.test(cleanPhone) &&
            !isInternationalPhoneNumber(cleanPhone)
          ) {
            newErrors.couple_phone_2 = isRTL
              ? "מספר טלפון לא תקין"
              : "Invalid phone number";
          } else {
            clearError("couple_phone_2");
          }
        }
      } else if (formData.event_type === "bar_bat_mitzvah") {
        if (!formData.mitzvah_type)
          newErrors.mitzvah_type = t.messages.required(t.fields.mitzvahType);
        else clearError("mitzvah_type");
        if (!formData.child_name.trim())
          newErrors.child_name = t.messages.required(t.fields.childName);
        else clearError("child_name");
        if (!formData.parent1_name.trim() && !formData.parent2_name.trim()) {
          newErrors.parent1_name = t.messages.atLeastOneParent;
        } else {
          clearError("parent1_name");
        }
        if (formData.parent1_phone !== "") {
          const cleanPhone = formData.parent1_phone.replace(/[^0-9]/g, "");
          if (
            !/^05\d{8}$/.test(cleanPhone) &&
            !isInternationalPhoneNumber(cleanPhone)
          ) {
            newErrors.parent1_phone = isRTL
              ? "מספר טלפון לא תקין"
              : "Invalid phone number";
          } else {
            clearError("parent1_phone");
          }
        }
        if (formData.parent2_phone !== "") {
          const cleanPhone = formData.parent2_phone.replace(/[^0-9]/g, "");
          if (
            !/^05\d{8}$/.test(cleanPhone) &&
            !isInternationalPhoneNumber(cleanPhone)
          ) {
            newErrors.parent2_phone = isRTL
              ? "מספר טלפון לא תקין"
              : "Invalid phone number";
          } else {
            clearError("parent2_phone");
          }
        }
      } else if (formData.event_type === "brit") {
        if (!formData.brit_type)
          newErrors.brit_type = t.messages.required(t.fields.britType);
        else clearError("brit_type");
        if (!formData.child_name.trim())
          newErrors.child_name = t.messages.required(t.fields.childName);
        else clearError("child_name");
        if (!formData.parent1_name.trim() && !formData.parent2_name.trim()) {
          newErrors.parent1_name = t.messages.atLeastOneParent;
        } else {
          clearError("parent1_name");
        }
        if (formData.parent1_phone !== "") {
          const cleanPhone = formData.parent1_phone.replace(/[^0-9]/g, "");
          if (
            !/^05\d{8}$/.test(cleanPhone) &&
            !isInternationalPhoneNumber(cleanPhone)
          ) {
            newErrors.parent1_phone = isRTL
              ? "מספר טלפון לא תקין"
              : "Invalid phone number";
          } else {
            clearError("parent1_phone");
          }
        }
        if (formData.parent2_phone !== "") {
          const cleanPhone = formData.parent2_phone.replace(/[^0-9]/g, "");
          if (
            !/^05\d{8}$/.test(cleanPhone) &&
            !isInternationalPhoneNumber(cleanPhone)
          ) {
            newErrors.parent2_phone = isRTL
              ? "מספר טלפון לא תקין"
              : "Invalid phone number";
          } else {
            clearError("parent2_phone");
          }
        }
      }
    }

    if (step === 3) {
      // Services & Approvals
      if (formData.activate_gift_service === null)
        newErrors.activate_gift_service = t.messages.required(
          t.fields.giftService,
        );
      else clearError("activate_gift_service");
      if (!formData.terms_agreed)
        newErrors.terms_agreed = t.messages.required(
          t.fields.termsAndConditions,
        );
      else clearError("terms_agreed");
      if (
        formData.activate_gift_service === true &&
        !formData.gift_terms_agreed
      ) {
        newErrors.gift_terms_agreed = t.messages.required(t.fields.giftService);
      } else {
        clearError("gift_terms_agreed");
      }
    }

    if (step === 4) {
      // Payment
      if (!formData.credit_card_number.trim()) {
        newErrors.credit_card_number = t.messages.required(t.fields.creditCard);
      } else if (
        !/^\d{4}[ -]?\d{4}[ -]?\d{4}[ -]?\d{4}$/.test(
          formData.credit_card_number.replace(/\s/g, ""),
        )
      ) {
        newErrors.credit_card_number = t.messages.invalidCreditCard;
      } else {
        clearError("credit_card_number");
      }

      if (!formData.card_holder_id.trim()) {
        newErrors.card_holder_id = t.messages.required(t.fields.cardHolderId);
      } else if (!/^\d{9}$/.test(formData.card_holder_id)) {
        newErrors.card_holder_id = t.messages.invalidID;
      } else {
        clearError("card_holder_id");
      }

      if (!formData.card_holder_name.trim())
        newErrors.card_holder_name = t.messages.required(
          t.fields.cardHolderName,
        );
      else clearError("card_holder_name");

      if (!formData.card_expiry.trim()) {
        newErrors.card_expiry = t.messages.required(t.fields.cardExpiry);
      } else if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(formData.card_expiry)) {
        newErrors.card_expiry = t.messages.invalidCardExpiry;
      } else {
        clearError("card_expiry");
      }

      if (!formData.card_cvv.trim()) {
        newErrors.card_cvv = t.messages.required(t.fields.cardCvv);
      } else if (!/^\d{3}$/.test(formData.card_cvv)) {
        newErrors.card_cvv = t.messages.invalidCvv;
      } else {
        clearError("card_cvv");
      }
    }

    setErrors(newErrors);

    const currentStepFields = {
      0: ["client_name", "client_phone", "client_phone_otp", "client_email"],
      1: ["event_date", "reception_time", "venue"],
      2: [
        "mitzvah_type",
        "brit_type",
        "child_name",
        "parent1_name",
        "couple_name_1",
        "couple_phone_1",
        "couple_name_2",
        "couple_phone_2",
        "parent1_phone",
        "parent2_phone",
      ],
      3: ["activate_gift_service", "terms_agreed", "gift_terms_agreed"],
      4: [
        "credit_card_number",
        "card_holder_id",
        "card_holder_name",
        "card_expiry",
        "card_cvv",
      ],
    }[step];

    // Ensure currentStepFields is an array before calling every
    if (!currentStepFields) {
      console.error(`Validation fields not defined for step ${step}`);
      return false;
    }

    return currentStepFields.every((field) => !newErrors[field]);
  };

  const handleNextStep = async () => {
    if (validateStep(formStep)) {
      if (formStep < formSteps.length - 1) {
        setAnimationDirection(1);
        setFormStep((prev) => prev + 1);
      } else {
        await handleFinalSubmit();
      }
    }
  };

  const handlePrevStep = () => {
    setAnimationDirection(-1);
    if (formStep > 0) {
      setFormStep((prev) => prev - 1);
    } else if (!isEventTypeFromUrl) {
      // If on the first step of the form, go back to event type selection
      setCurrentStage(STAGES.SELECT_EVENT_TYPE);
    }
  };

  const handleFinalSubmit = async () => {
    try {
      const dataToSubmit = {
        ...formData,
        event_date: formData.event_date
          ? format(formData.event_date, "yyyy-MM-dd")
          : null,
        activate_gift_service:
          formData.activate_gift_service === "yes" ||
          formData.activate_gift_service === true,
        want_seating_service:
          formData.want_seating_service === true ? true : false,
      };

      // Normalize phone numbers to digits only before sending to the server.
      // The server validates with strict digit-only patterns, so values like
      // "050-59-597-27" or "+972505959727" must be sent as "0505959727" /
      // "972505959727".
      [
        "client_phone",
        "parent1_phone",
        "parent2_phone",
        "couple_phone_1",
        "couple_phone_2",
      ].forEach((field) => {
        if (typeof dataToSubmit[field] === "string") {
          dataToSubmit[field] = dataToSubmit[field].replace(/[^0-9]/g, "");
        }
      });

      // Remove unused subtype fields
      if (dataToSubmit.event_type !== "bar_bat_mitzvah")
        delete dataToSubmit.mitzvah_type;
      if (dataToSubmit.event_type !== "brit") delete dataToSubmit.brit_type;
      if (
        dataToSubmit.event_type !== "wedding" &&
        dataToSubmit.event_type !== "henna"
      ) {
        delete dataToSubmit.couple_name_1;
        delete dataToSubmit.couple_phone_1;
        delete dataToSubmit.couple1_parent1_name;
        delete dataToSubmit.couple1_parent2_name;
        delete dataToSubmit.couple_name_2;
        delete dataToSubmit.couple_phone_2;
        delete dataToSubmit.couple2_parent1_name;
        delete dataToSubmit.couple2_parent2_name;

        dataToSubmit.parent1_1_name = dataToSubmit.parent1_name;
        dataToSubmit.parent1_2_name = dataToSubmit.parent2_name;
        dataToSubmit.manager_name_1 = dataToSubmit.parent1_name;
        dataToSubmit.manager_phone_1 = dataToSubmit.parent1_phone;
        dataToSubmit.manager_name_2 = dataToSubmit.parent2_name;
        dataToSubmit.manager_phone_2 = dataToSubmit.parent2_phone;

        delete dataToSubmit.child_name;
        delete dataToSubmit.parent1_name;
        delete dataToSubmit.parent1_phone;
        delete dataToSubmit.parent2_name;
        delete dataToSubmit.parent2_phone;
      }
      if (
        dataToSubmit.event_type !== "bar_bat_mitzvah" &&
        dataToSubmit.event_type !== "brit"
      ) {
        delete dataToSubmit.child_name;
        delete dataToSubmit.parent1_name;
        delete dataToSubmit.parent1_phone;
        delete dataToSubmit.parent2_name;
        delete dataToSubmit.parent2_phone;

        dataToSubmit.manager_name_1 = dataToSubmit.couple_name_1;
        dataToSubmit.manager_phone_1 = dataToSubmit.couple_phone_1;
        dataToSubmit.parent1_1_name = dataToSubmit.couple1_parent1_name;
        dataToSubmit.parent1_2_name = dataToSubmit.couple1_parent2_name;
        dataToSubmit.manager_name_2 = dataToSubmit.couple_name_2;
        dataToSubmit.manager_phone_2 = dataToSubmit.couple_phone_2;
        dataToSubmit.parent2_1_name = dataToSubmit.couple2_parent1_name;
        dataToSubmit.parent2_2_name = dataToSubmit.couple2_parent2_name;

        delete dataToSubmit.couple_name_1;
        delete dataToSubmit.couple_phone_1;
        delete dataToSubmit.couple1_parent1_name;
        delete dataToSubmit.couple1_parent2_name;
        delete dataToSubmit.couple_name_2;
        delete dataToSubmit.couple_phone_2;
        delete dataToSubmit.couple2_parent1_name;
        delete dataToSubmit.couple2_parent2_name;
      }
      dataToSubmit.package_id = packageDetails.package_id;
      dataToSubmit.event_type_id = eventTypeDetail.event_type_id;
      dataToSubmit.short_link = shortLink;
      dataToSubmit.package_hash = packageHash;
      setSubmittedData(dataToSubmit);
      setIsSubmitting(true);
      const res = await api.post(
        `/CreateEvent/${packageDetails.identifier}`,
        dataToSubmit,
      );
      setIsSubmitting(false);
      if (!res.data.success) {
        toast.error(res.data.message || "Submission failed. Please try again.");
      } else if (res.data.success) {
        setInvoices(res.data.data.invoices || []);
        setIsSubmitted(true);
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error submitting form:", error);
      const message = error?.response?.data?.message;
      if (message) toast.error(message);
      else toast.error(t.errorOccured);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
    if (field === "client_phone") {
      if (isPhoneFromUrl) {
        setIsPhoneFromUrl(false);
      }
      setIsPhoneVerified(false);
      setErrors((prev) => ({ ...prev, client_phone_otp: "" }));
    }
  };

  const handleEventTypeSelect = (eventTypeInternalValue) => {
    const preservedClientPhone = isPhoneFromUrl ? formData.client_phone : "";
    const preservedPhoneVerified = isPhoneFromUrl ? isPhoneVerified : false;
    const preservedIsPhoneFromUrl = isPhoneFromUrl;

    setFormData({
      ...initialFormData,
      client_phone: preservedClientPhone,
      event_type: eventTypeInternalValue,
    });
    setCurrentStage(STAGES.FILL_DETAILS);
    setFormStep(0);
    setErrors({});
    setIsEditingEventName(false);
    setIsPhoneVerified(preservedPhoneVerified);
    setIsPhoneFromUrl(preservedIsPhoneFromUrl);
  };

  const handleSendOtp = async () => {
    if (validateStep(0)) {
      const cleanPhone = formData.client_phone.replace(/[^0-9]/g, "");
      if (!formData.client_phone || !/^05\d{8}$/.test(cleanPhone)) {
        setErrors((prev) => ({
          ...prev,
          client_phone: isRTL
            ? 'המספר טלפון לא תקין, לא ניתן להירשם עם מספר חו"ל'
            : "Invalid phone number, cannot register with international number",
        }));
        return;
      }
      setIsSendingOtp(true);
      setOtpError("");
      const res = await api.post(
        `/users/RegisterIfNotExistAndSendOTP?phone=${
          formData.client_phone
        }&name=${encodeURIComponent(
          formData.client_name,
        )}&email=${encodeURIComponent(formData.client_email)}&token=${
          packageDetails.identifier
        }&entityId=${packageDetails.package_id}`,
      );
      if (!res.data.success) {
        setErrors((prev) => ({
          ...prev,
          client_phone: res.data.message || t.messages.otpSendFailed,
        }));
        setIsSendingOtp(false);
        return;
      }
      setShowOtpPopup(true);
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    setIsVerifyingOtp(true);
    setOtpError("");
    const res = await api.post(
      `users/ValidateOTP?phone=${formData.client_phone}&otp=${otpValue}`,
    );
    if (res.data.success) {
      handleNextStep();
      setIsPhoneVerified(true);
      setShowOtpPopup(false);
      setOtpValue("");
      setErrors((prev) => ({ ...prev, client_phone_otp: "" }));
    } else {
      setOtpError(t.messages.otpInvalid);
    }
    setIsVerifyingOtp(false);
  };

  const handleDownloadPdf = () => {
    if (!submittedData) return;

    const fieldLabels = {
      //    event_type: t.fields.eventTypes.wedding, // Default, will be overwritten
      mitzvah_type: t.fields.mitzvahType,
      brit_type: t.fields.britType,
      event_name: t.fields.eventName,
      client_name: t.fields.fullName,
      client_phone: t.fields.phone,
      client_email: t.fields.email,
      event_date: t.fields.eventDate,
      reception_time: t.fields.receptionTime,
      venue: t.fields.venue,
      couple_name_1: t.fields.coupleName1,
      couple_phone_1: t.fields.couplePhone1,
      couple1_parent1_name: t.fields.couple1Parent1,
      couple1_parent2_name: t.fields.couple1Parent2,
      couple_name_2: t.fields.coupleName2,
      couple_phone_2: t.fields.couplePhone2,
      couple2_parent1_name: t.fields.couple2Parent1,
      couple2_parent2_name: t.fields.couple2Parent2,
      child_name: t.fields.childName,
      parent1_name: t.fields.parent1Name,
      parent1_phone: t.fields.parent1Phone,
      parent2_name: t.fields.parent2Name,
      parent2_phone: t.fields.parent2Phone,
      activate_gift_service: t.fields.giftService,
      want_seating_service: t.fields.seatingServiceTitle,
      special_requests: t.fields.specialRequests,
      terms_agreed: t.fields.termsAndConditions,
      gift_terms_agreed: t.fields.giftTermsLink,
    };

    const eventTypeLabels = {
      wedding: t.eventTypes.wedding,
      bar_bat_mitzvah: t.eventTypes.bar_bat_mitzvah,
      brit: t.eventTypes.brit,
    };
    const activationStatus = {
      true: isRTL ? "פעיל" : "Active",
      false: isRTL ? "לא פעיל" : "Inactive",
    };

    let content = `
            <div style="padding: 2rem; font-family: 'Noto Sans Hebrew', Arial, sans-serif;" dir="${
              isRTL ? "rtl" : "ltr"
            }">
                <h1 style="text-align: center; color: #c2417d; border-bottom: 2px solid #fce7f3; padding-bottom: 1rem; margin-bottom: 2rem;">${
                  isRTL
                    ? "סיכום טופס רישום - WiWi"
                    : "WiWi Registration Summary"
                }</h1>
                
                <!-- <h2 style="color: #be185d; margin-top: 2rem; border-bottom: 1px solid #f9a8d4; padding-bottom: 0.5rem;">${
                  packageDetails.name
                }</h2> -->
                <div style="background: #fdf2f8; padding: 1rem; border-radius: 8px; margin-bottom: 2rem;">
                    <h3 style="color: #be185d; margin-bottom: 1rem;">${
                      packageDetails.name
                    }</h3>
                    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; text-align: center;">
                        <div style="background: white; padding: 1rem; border-radius: 8px;">
                            <div style="color: #666; font-size: 0.9rem;">${
                              t.package.deposit
                            } (${t.package.depositNote})</div>
                            <div style="color: #be185d; font-weight: bold; font-size: 1.2rem;">${
                              packageDetails.deposit
                            } ש"ח</div>
                        </div>
                        <div style="background: white; padding: 1rem; border-radius: 8px;">
                            <div style="color: #666; font-size: 0.9rem;">${
                              t.package.pricePerRecord
                            } </div>
                            <div style="color: #be185d; font-weight: bold; font-size: 1.2rem;">${
                              packageDetails.per_successful_registration
                            } ש"ח</div>
                        </div>
                        <div style="background: white; padding: 1rem; border-radius: 8px;">
                            <div style="color: #666; font-size: 0.9rem;">${
                              t.package.giftService
                            }</div>
                            <div style="color: #be185d; font-weight: bold; font-size: 1.2rem;">${
                              submittedData.activate_gift_service === true
                                ? `${eventTypeDetail?.gift_charge || "159"} ש"ח`
                                : isRTL
                                  ? "לא פעיל"
                                  : "Inactive"
                            }</div>
                        </div>
                    </div>
                    <p style="margin-top: 1rem; font-size: 0.9rem; color: #be185d;"><strong>${t.package.successfulRecord}</strong> = ${t.package.successfulRecordDesc}</p>
                    <p style="margin-top: 0.5rem; font-size: 0.9rem; color: #be185d;">* המקדמה תקוזז מהתשלום הסופי - החיוב הסופי יתבצע יום לאחר האירוע באמצעות כרטיס האשראי שנמסר.</p>
                </div>
                
                <h2 style="color: #be185d; margin-top: 2rem; border-bottom: 1px solid #f9a8d4; padding-bottom: 0.5rem;">${
                  t.formSteps.eventDetails
                }</h2>
        `;

    const renderRow = (label, value) => {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === false
      )
        return "";
      let displayValue = value;
      if (typeof value === "boolean")
        displayValue = value ? (isRTL ? "כן" : "Yes") : isRTL ? "לא" : "No";
      if (
        label === eventTypeLabels.wedding ||
        label === eventTypeLabels.bar_bat_mitzvah ||
        label === eventTypeLabels.brit
      )
        displayValue = eventTypeLabels[value] || value;
      if (label === fieldLabels.event_date && value) {
        const date = new Date(value);
        displayValue = format(date, "dd/MM/yyyy");
      }
      if (label === fieldLabels.mitzvah_type)
        displayValue =
          value === "bar"
            ? isRTL
              ? "בר מצווה"
              : "Bar Mitzvah"
            : isRTL
              ? "בת מצווה"
              : "Bat Mitzvah";
      if (label === fieldLabels.brit_type)
        displayValue =
          value === "boy"
            ? isRTL
              ? "ברית"
              : "Brit Milah"
            : isRTL
              ? "בריתה"
              : "Brit Bat";
      if (label === fieldLabels.activate_gift_service)
        displayValue = activationStatus[value] || value;
      if (label === fieldLabels.terms_agreed) {
        const currentTime = new Date().toLocaleTimeString("he-IL", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        const currentDate = new Date().toLocaleDateString("he-IL");
        displayValue = value
          ? `קראתי והבנתי בתאריך: ${currentDate} בשעה: ${currentTime} - <a href="https://app.wiwi.co.il/terms" target="_blank" style="color: #be185d; text-decoration: underline;">https://app.wiwi.co.il/terms</a>`
          : isRTL
            ? "לא"
            : "No";
      }
      if (label === fieldLabels.gift_terms_agreed) {
        const currentTime = new Date().toLocaleTimeString("he-IL", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        const currentDate = new Date().toLocaleDateString("he-IL");
        displayValue = value
          ? `קראתי והבנתי בתאריך: ${currentDate} בשעה: ${currentTime} - <a href="https://app.wiwi.co.il/terms" target="_blank" style="color: #be185d; text-decoration: underline;">https://app.wiwi.co.il/terms</a>`
          : isRTL
            ? "לא"
            : "No";
      }
      if (label === fieldLabels.want_seating_service)
        displayValue = activationStatus[value] || value;

      return `<div style="display: flex; justify-content: space-between; padding: 0.5rem 0; border-bottom: 1px dashed #f5d0e4;">
                        <strong style="color: #333;">${label}:</strong>
                        <span style="color: #555; text-align: ${
                          isRTL ? "left" : "right"
                        };">${displayValue}</span>
                      </div>`;
    };

    for (const key in submittedData) {
      // Special handling for event_type label lookup
      const currentLabel =
        key === "event_type"
          ? isRTL
            ? eventTypes[submittedData[key]]?.label
            : eventTypes[submittedData[key]]?.labelEn
          : fieldLabels[key];

      if (
        currentLabel &&
        !key.startsWith("card") &&
        key !== "credit_card_number"
      ) {
        content += renderRow(currentLabel, submittedData[key]);
      }
    }

    content += `
                <div style="margin-top: 2rem; padding: 1rem; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0;">
                    <h3 style="color: #be185d; margin-bottom: 1rem; text-align: center;">קישורים חשובים</h3>
                    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem; text-align: center;">
                        <div style="background: white; padding: 0.75rem; border-radius: 6px; border: 1px solid #e2e8f0;">
                            <div style="color: #be185d; font-weight: bold; margin-bottom: 0.25rem;">מערכת WiWi</div>
                            <div style="color: #666; font-size: 0.9rem;"><a href="https://app.wiwi.co.il" target="_blank" style="color: #be185d; text-decoration: underline;">https://app.wiwi.co.il</a></div>
                        </div>
                        <div style="background: white; padding: 0.75rem; border-radius: 6px; border: 1px solid #e2e8f0;">
                            <div style="color: #be185d; font-weight: bold; margin-bottom: 0.25rem;">סרטוני הדרכה</div>
                            <div style="color: #666; font-size: 0.9rem;"><a href="https://bit.ly/wiwiytb" target="_blank" style="color: #be185d; text-decoration: underline;">https://bit.ly/wiwiytb</a></div>
                        </div>
                        <div style="background: white; padding: 0.75rem; border-radius: 6px; border: 1px solid #e2e8f0;">
                            <div style="color: #be185d; font-weight: bold; margin-bottom: 0.25rem;">שירות לקוחות</div>
                            <div style="color: #666; font-size: 0.9rem;"><a href="https://wa.me/972539242324" target="_blank" style="color: #be185d; text-decoration: underline;">https://wa.me/972539242324</a></div>
                        </div>
                    </div>
                </div>
            </div>`;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
            <html>
                <head>
                    <title>${
                      isRTL ? "סיכום רישום WiWi" : "WiWi Registration Summary"
                    }</title>
                    <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@400;700&display=swap" rel="stylesheet">
                    <style>
                        body { font-family: "Noto Sans Hebrew", sans-serif; margin: 0; padding: 0; }
                        h1 { font-size: 2em; }
                        h2 { font-size: 1.5em; }
                    </style>
                </head>
                <body>${content}</body>
            </html>
        `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };

  const renderInput = (
    id,
    label,
    placeholder,
    value,
    onChange,
    error,
    type = "text",
    isPhoneInput = false,
    icon,
    disabled = false,
  ) => {
    const isClientPhoneField = id === "client_phone";
    const isEmailField = id === "client_email";
    const isCreditCardField = id === "credit_card_number";
    const isCardExpiryField = id === "card_expiry";
    const isCvvField = id === "card_cvv";
    const isIdField = id === "card_holder_id";
    const hasError = error && typeof error === "string";

    let isMandatory = [
      "client_name",
      "client_phone",
      "client_email",
      "event_date",
      "reception_time",
      "venue",
    ].includes(id);

    if (
      formData.activate_gift_service === true &&
      [
        "credit_card_number",
        "card_holder_id",
        "card_holder_name",
        "card_expiry",
        "card_cvv",
      ].includes(id)
    ) {
      isMandatory = true;
    }

    if (
      (formData.event_type === "bar_bat_mitzvah" ||
        formData.event_type === "brit") &&
      id === "child_name"
    ) {
      isMandatory = true;
    }
    if (
      (formData.event_type === "wedding" || formData.event_type === "henna") &&
      (id === "couple_name_1" || id === "couple_name_2")
    ) {
      isMandatory = true;
    }

    const labelText = `${label}${isMandatory ? " *" : ""}`;

    return (
      <div className="space-y-2">
        <Label htmlFor={id} className="text-gray-700 font-medium">
          {labelText}
        </Label>
        <div className="relative flex items-center">
          {icon && !isClientPhoneField && (
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5">
              {icon}
            </div>
          )}
          {isClientPhoneField && isPhoneVerified && (
            <ShieldCheck
              className={`absolute ${
                isRTL ? "right-3" : "left-3"
              } top-1/2 transform -translate-y-1/2 text-green-500 w-5 h-5`}
            />
          )}

          <Input
            id={id}
            type={type}
            value={value}
            onChange={(e) => {
              let val = e.target.value;
              if (isCreditCardField) {
                val = val
                  .replace(/\D/g, "")
                  .replace(/(\d{4})(?=\d)/g, "$1 ")
                  .substring(0, 19);
              }
              if (isCardExpiryField) {
                val = val.replace(/\D/g, "");
                if (val.length > 2) {
                  val = val.substring(0, 2) + "/" + val.substring(2, 4);
                }
                val = val.substring(0, 5);
              }
              if (isCvvField) {
                val = val.replace(/\D/g, "").substring(0, 3);
              }
              if (isIdField) {
                val = val.replace(/\D/g, "").substring(0, 9);
              }
              if (id === "reception_time") {
                val = val.replace(/\D/g, "");
                if (val.length >= 2) {
                  val = val.substring(0, 2) + ":" + val.substring(2, 4);
                }
                val = val.substring(0, 5);
              }
              onChange(id, val);
            }}
            className={`h-12 rounded-xl border-2 transition-all focus:ring-0 focus:outline-none w-full ${
              (icon && !isClientPhoneField) ||
              (isClientPhoneField && isPhoneVerified)
                ? isRTL
                  ? "pr-10"
                  : "pl-10"
                : ""
            } ${
              hasError
                ? "border-red-300"
                : "border-gray-200 focus:border-rose-300"
            } ${
              disabled || (isClientPhoneField && isPhoneFromUrl)
                ? "bg-gray-100 cursor-not-allowed"
                : ""
            }`}
            placeholder={placeholder}
            dir={
              isPhoneInput ||
              isEmailField ||
              type === "time" ||
              id === "reception_time" ||
              isCreditCardField ||
              isCardExpiryField ||
              isCvvField ||
              isIdField
                ? "ltr"
                : isRTL
                  ? "rtl"
                  : "ltr"
            }
            disabled={disabled || (isClientPhoneField && isPhoneFromUrl)}
          />
        </div>
        {hasError && <p className="text-red-500 text-sm">{error}</p>}
        {isClientPhoneField && errors.client_phone_otp && (
          <p className="text-red-500 text-sm">{errors.client_phone_otp}</p>
        )}
      </div>
    );
  };

  const renderBusinessSummary = () => (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl border-2 border-rose-200 p-6 mb-8 shadow-sm"
    >
      <div className="text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Gift className="w-6 h-6 text-rose-600" />
          <h3 className="text-xl font-bold text-rose-900">
            {packageDetails.name}
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
          <div className="bg-white/70 rounded-xl p-4 border border-rose-100 flex flex-col justify-between">
            <div>
              <div className="text-sm text-gray-600 mb-1">
                {t.package.deposit}
              </div>
              <div className="text-2xl font-bold text-rose-600">
                {packageDetails.deposit} ש&quot;ח
              </div>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              {t.package.depositNote}
            </p>
          </div>

          <div className="bg-white/70 rounded-xl p-4 border border-rose-100">
            <div className="text-sm text-gray-600 mb-1">
              {t.package.pricePerRecord}
            </div>
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-gray-400 line-through text-sm">
                {isRTL ? "2.00 ₪" : "₪2.00"}
              </span>
              <span className="text-2xl font-bold text-rose-600">
                {packageDetails.per_successful_registration} ש&quot;ח
              </span>
            </div>
          </div>

          <div className="bg-white/70 rounded-xl p-4 border border-rose-100">
            <div className="text-sm text-gray-600 mb-1">
              {t.package.giftService}
            </div>
            <div className="flex items-baseline justify-center gap-2">
              {eventTypeDetail.original_gift_charges >
                eventTypeDetail.gift_charge && (
                <span className="text-gray-400 line-through text-sm">
                  {isRTL ? "200 ₪" : "₪200"}
                </span>
              )}
              <span className="text-2xl font-bold text-rose-600">
                {eventTypeDetail.gift_charge} ש&quot;ח
              </span>
            </div>
          </div>
        </div>

        <div className="mt-4 p-3 bg-rose-100/50 rounded-lg border border-rose-200">
          <p className="text-sm text-rose-800 leading-relaxed">
            {t.package.successfulRecordDesc}
          </p>
          {/* <p className="text-sm text-rose-800 leading-relaxed mt-2">
            המקדמה תקוזז מהתשלום הסופי - החיוב הסופי יתבצע יום לאחר האירוע
            באמצעות כרטיס האשראי שנמסר.
          </p> */}
        </div>
      </div>
    </motion.div>
  );

  const renderInvoicesTable = () => (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl border-2 border-rose-200 p-6 mb-8 shadow-sm"
    >
      <div className="text-center mb-6">
        <div className="flex items-center justify-center gap-2 mb-4">
          <FileText className="w-6 h-6 text-rose-600" />
          <h3 className="text-xl font-bold text-rose-900">
            {isRTL ? "חשבוניות" : "Invoices"}
          </h3>
        </div>
      </div>

      <div className="bg-white/70 rounded-xl overflow-hidden border border-rose-100 shadow-sm">
        <Table>
          <TableHeader>
            <TableRow className="bg-rose-100/50 hover:bg-rose-100/70 border-b-2 border-rose-200">
              <TableHead
                className={`font-bold text-rose-900 py-4 px-6 ${
                  isRTL ? "text-right" : "text-left"
                }`}
              >
                {isRTL ? "סוג חשבונית" : "Invoice Type"}
              </TableHead>
              <TableHead
                className={`font-bold text-rose-900 py-4 px-6 ${
                  isRTL ? "text-right" : "text-left"
                }`}
              >
                {isRTL ? "סכום (₪)" : "Amount (₪)"}
              </TableHead>
              <TableHead
                className={`font-bold text-rose-900 py-4 px-6 text-center`}
              >
                {isRTL ? "הורדה" : "Download"}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {invoices && invoices.length > 0 ? (
              invoices.map((invoice, index) => (
                <TableRow
                  key={invoice.id || index}
                  className="hover:bg-rose-50/40 transition-colors border-b border-rose-100/50"
                >
                  <TableCell
                    className={`font-medium text-gray-700 py-4 px-6 ${
                      isRTL ? "text-right" : "text-left"
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-rose-400 rounded-full"></div>
                      <span className="text-sm text-gray-800">
                        {isRTL
                          ? translations.he.invoices[invoice.type]
                          : translations.en.invoices[invoice.type]}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell
                    className={`text-gray-700 py-4 px-6 ${
                      isRTL ? "text-right" : "text-left"
                    }`}
                  >
                    <span className="font-bold text-lg text-rose-600 bg-rose-50 px-3 py-1 rounded-lg">
                      {invoice.totalAmount ? `${invoice.totalAmount}` : "-"}
                    </span>
                  </TableCell>
                  <TableCell className="py-4 px-6 text-center">
                    <button
                      onClick={() => window.open(invoice.invoiceURL, "_blank")}
                      disabled={!invoice.invoiceURL}
                      className={`inline-flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200 ${
                        invoice.invoiceURL
                          ? "bg-rose-500 hover:bg-rose-600 text-white hover:scale-110 shadow-md hover:shadow-lg"
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                      }`}
                      title={isRTL ? "הורד חשבונית" : "Download Invoice"}
                    >
                      <Download className="w-4 h-4" />
                    </button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={3}
                  className={`text-center text-gray-500 py-12 px-6 ${
                    isRTL ? "text-right" : "text-left"
                  }`}
                >
                  <div className="flex flex-col items-center gap-3">
                    <FileText className="w-12 h-12 text-gray-300" />
                    <span className="text-lg">
                      {isRTL ? "אין חשבוניות זמינות" : "No invoices available"}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </motion.div>
  );

  const renderEventTypeSelection = () => (
    <motion.div
      key="eventTypeSelection"
      initial={{ opacity: 0, x: isRTL ? "50%" : "-50%" }}
      animate={{ opacity: 1, x: "0%" }}
      exit={{ opacity: 0, x: isRTL ? "-50%" : "50%" }}
      transition={{ duration: 0.5 }}
      className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-8 md:p-12"
    >
      <div className="text-center mb-8">
        <Heart className="w-10 h-10 text-rose-500 mx-auto mb-4" />
        <h3 className="text-2xl font-semibold text-gray-800 mb-2">
          {t.eventTypeSelectionTitle}
        </h3>
        <p className="text-gray-600">{t.eventTypeSelectionSubtitle}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.values(eventTypes).map(
          ({ label, labelEn, icon: Icon, internalValue }) => (
            <motion.button
              key={internalValue}
              onClick={() => handleEventTypeSelect(internalValue)}
              className="flex flex-col items-center justify-center p-6 bg-white hover:bg-rose-50 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-transparent hover:border-rose-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Icon className="w-8 h-8 text-rose-500 mb-3" />
              <span className="text-lg font-medium text-gray-700">
                {isRTL ? label : labelEn}
              </span>
            </motion.button>
          ),
        )}
      </div>
    </motion.div>
  );

  const handleReferralSubmit = async () => {
    const validFriends = referralFriends.filter(
      (friend) =>
        friend.name.trim() &&
        friend.phone &&
        /^\d{10}$/.test(friend.phone.replace(/[^0-9]/g, "")),
    );
    if (validFriends.length > 0 && referralTermsAgreed) {
      setIsSubmittingReferral(true);
      try {
        await fetch(
          "https://hook.nuvola.co.il/webhook/1dc46ab1-8a89-4f43-9dc7-a6bbf18d9221",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              referrals: validFriends,
              referrer: {
                name: formData.client_name,
                phone: formData.client_phone,
                email: formData.client_email,
              },
            }),
          },
        );
      } catch (error) {
        console.error("Error sending referral:", error);
      }
      setReferralSubmitted(true);
      setReferralFriends([{ name: "", phone: "" }]);
      setReferralTermsAgreed(false);
      setIsSubmittingReferral(false);
    }
  };

  const addReferralField = () => {
    setReferralFriends([...referralFriends, { name: "", phone: "" }]);
  };

  const removeReferralField = (index) => {
    if (referralFriends.length > 1) {
      const newFriends = referralFriends.filter((_, i) => i !== index);
      setReferralFriends(newFriends);
    }
  };

  const updateReferralFriend = (index, field, value) => {
    const newFriends = [...referralFriends];
    newFriends[index][field] = value;
    setReferralFriends(newFriends);
  };

  const renderSeatingServiceOffer = () => (
    <motion.div
      key="seatingService"
      initial={{ opacity: 0, x: isRTL ? "50%" : "-50%" }}
      animate={{ opacity: 1, x: "0%" }}
      exit={{ opacity: 0, x: isRTL ? "-50%" : "50%" }}
      transition={{ duration: 0.5 }}
      className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-8 md:p-12"
    >
      <div className="text-center mb-8">
        <Users className="w-12 h-12 text-rose-500 mx-auto mb-4" />
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
          {t.fields.seatingServiceTitle}
        </h2>
        <div className="flex items-baseline justify-center gap-2 mb-6">
          <span className="text-gray-400 line-through text-xl md:text-2xl">
            {isRTL ? "2,000 ₪" : "₪2,000"}
          </span>
          <span className="text-3xl md:text-4xl font-bold text-rose-600">
            {isRTL ? "1,600 ₪" : "₪1,600"}
          </span>
        </div>
        <p className="text-gray-600 mb-8 text-sm md:text-base">
          {t.fields.seatingServiceSubtitle}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8">
        <div className="bg-rose-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-rose-900 mb-4 flex items-center gap-2">
            <Clock className="w-6 h-6" />
            {t.fields.howItWorks}
          </h3>
          <div className="space-y-3 text-gray-700">
            <div className="flex items-start gap-3">
              <Check
                className={`w-5 h-5 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDesc1}</p>
            </div>
            <div className="flex items-start gap-3">
              <Check
                className={`w-5 h-5 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDesc2}</p>
            </div>
            <div className="flex items-start gap-3">
              <Check
                className={`w-5 h-5 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDesc3}</p>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center gap-2">
            <Users className="w-6 h-6" />
            {t.fields.whatDoTheyDo}
          </h3>
          <div className="space-y-2 text-gray-700 text-sm">
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties1}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties2}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties3}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties4}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties5}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties6}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties7}</p>
            </div>
            <div className="flex items-start gap-2">
              <Check
                className={`w-4 h-4 text-green-500 mt-0.5 flex-shrink-0 ${
                  isRTL ? "ml-0" : "mr-0"
                }`}
              />
              <p>{t.fields.seatingDuties8}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-rose-100 to-pink-100 rounded-xl p-6 mb-8">
        <h3 className="text-lg font-bold text-gray-800 mb-4">
          {t.fields.interestedInSeating}
        </h3>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            type="button"
            variant={
              formData.want_seating_service === true ? "default" : "outline"
            }
            onClick={() => handleInputChange("want_seating_service", true)}
            className={`flex-1 h-12 rounded-lg transition-all duration-200 ${
              formData.want_seating_service === true
                ? "bg-rose-500 text-white border-rose-500"
                : "text-gray-700 border-gray-300 hover:bg-rose-50 hover:border-rose-400"
            }`}
          >
            <Check
              className={`w-5 h-5 ${isRTL ? "ml-2" : "mr-2"} ${
                formData.want_seating_service === true
                  ? "text-white"
                  : "text-green-500"
              }`}
            />
            {t.fields.yesInterested}
          </Button>
          <Button
            type="button"
            variant={
              formData.want_seating_service === false ? "default" : "outline"
            }
            onClick={() => handleInputChange("want_seating_service", false)}
            className={`flex-1 h-12 rounded-lg transition-all duration-200 ${
              formData.want_seating_service === false
                ? "bg-gray-600 text-white border-gray-600"
                : "text-gray-700 border-gray-300 hover:bg-gray-100 hover:border-gray-400"
            }`}
          >
            <X
              className={`w-5 h-5 ${isRTL ? "ml-2" : "mr-2"} ${
                formData.want_seating_service === false
                  ? "text-white"
                  : "text-red-500"
              }`}
            />
            {t.fields.noThanks}
          </Button>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <Button
          type="button"
          onClick={handleFinalSubmit}
          disabled={isSubmitting || formData.want_seating_service === null}
          className="flex-1 h-14 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white text-lg font-semibold rounded-xl shadow-lg transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <div className="flex items-center gap-3 justify-center">
              <Loader2
                className={`h-5 w-5 animate-spin ${isRTL ? "ml-2" : "mr-2"}`}
              />
              {t.messages.otpSending}
            </div>
          ) : (
            <div className="flex items-center gap-3 justify-center">
              <Send className="w-5 h-5" />
              {t.buttons.submit}
            </div>
          )}
        </Button>
      </div>
    </motion.div>
  );

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? (isRTL ? "-100%" : "100%") : isRTL ? "100%" : "-100%",
      opacity: 0,
      position: "absolute",
      width: "100%",
    }),
    center: {
      x: 0,
      opacity: 1,
      position: "relative",
      width: "100%",
    },
    exit: (direction) => ({
      x: direction < 0 ? (isRTL ? "-100%" : "100%") : isRTL ? "100%" : "-100%",
      opacity: 0,
      position: "absolute",
      width: "100%",
    }),
  };

  const renderFormDetails = () => (
    <motion.div
      key="formDetails"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-8 md:p-12"
    >
      {renderBusinessSummary()}

      <div className="mb-6 flex justify-between items-center">
        <h3 className="text-xl font-semibold text-gray-700">
          {isRTL ? "אירוע" : "Event"}:{" "}
          <span className="text-rose-500">
            {isRTL
              ? eventTypes[formData.event_type]?.label
              : eventTypes[formData.event_type]?.labelEn}
          </span>
        </h3>
        {!isEventTypeFromUrl && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setCurrentStage(STAGES.SELECT_EVENT_TYPE)}
            className="flex items-center gap-1"
          >
            <Edit3 className="w-3 h-3" /> {t.buttons.changeEventType}
          </Button>
        )}
      </div>

      <div className="mb-8">
        <div className="mb-2">
          <p className="text-sm text-center text-gray-600">
            {t.messages.stepOfTotal(formStep + 1, formSteps.length)}
          </p>
        </div>
        <div className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          {formSteps.map((step, index) => (
            <div key={step.id} className="flex-1">
              <div
                className={`h-full rounded-full transition-all duration-500 ${
                  formStep >= index ? "bg-rose-500" : "bg-gray-200"
                }`}
              ></div>
            </div>
          ))}
        </div>
        <h3 className="text-center text-xl font-semibold text-gray-800 mt-4">
          {formSteps[formStep].name}
        </h3>
      </div>

      <div className="overflow-hidden relative">
        <AnimatePresence initial={false} custom={animationDirection}>
          <motion.div
            key={formStep}
            custom={animationDirection}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
              x: { type: "spring", stiffness: 300, damping: 30 },
              opacity: { duration: 0.2 },
            }}
            className="w-full"
          >
            {formStep === 0 && (
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {renderInput(
                    "client_name",
                    t.fields.fullName,
                    t.placeholders.enterFullName,
                    formData.client_name,
                    handleInputChange,
                    errors.client_name,
                  )}
                  {renderInput(
                    "client_phone",
                    t.fields.phone,
                    t.placeholders.phoneNumber,
                    formData.client_phone,
                    handleInputChange,
                    errors.client_phone || errors.client_phone_otp,
                    "tel",
                    true,
                    null,
                  )}
                  <div className="md:col-span-2">
                    {renderInput(
                      "client_email",
                      t.fields.email,
                      t.placeholders.email,
                      formData.client_email,
                      handleInputChange,
                      errors.client_email,
                      "email",
                      false,
                      <Mail className="w-5 h-5" />,
                    )}
                  </div>
                </div>
                {!isPhoneVerified &&
                !isPhoneFromUrl &&
                formData.client_phone.length > 0 &&
                /^\d{10}$/.test(
                  formData.client_phone.replace(/[^0-9]/g, ""),
                ) ? (
                  <p className="text-sm text-center text-amber-700 mt-2">
                    {t.messages.phoneVerificationNeeded}
                  </p>
                ) : null}
                {/* {isPhoneFromUrl && (
                  <p className="text-sm text-center text-green-600 mt-2 flex items-center justify-center gap-2">
                    <ShieldCheck className="w-4 h-4" />
                    {t.messages.phoneVerified}
                  </p>
                )} */}
              </div>
            )}
            {formStep === 1 && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <Label className="text-gray-700 font-medium">
                    {t.fields.eventDate} *
                  </Label>
                  <Popover>
                    <PopoverTrigger asChild>
                      <Button
                        variant="outline"
                        className={`w-full h-12 rounded-xl border-2 justify-start text-${
                          isRTL ? "right" : "left"
                        } font-normal transition-all focus:ring-0 focus:outline-none ${
                          errors.event_date
                            ? "border-red-300"
                            : "border-gray-200 hover:border-rose-300 focus:border-rose-300"
                        }`}
                      >
                        <CalendarIcon
                          className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`}
                        />
                        {formData.event_date
                          ? format(formData.event_date, "dd/MM/yyyy", {
                              locale: dateLocale,
                            })
                          : t.placeholders.selectDate}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent
                      className="w-auto p-0"
                      align={isRTL ? "end" : "start"}
                    >
                      <Calendar
                        mode="single"
                        selected={formData.event_date}
                        onSelect={(date) =>
                          handleInputChange("event_date", date)
                        }
                        locale={dateLocale}
                        disabled={(date) =>
                          startOfDay(date) <
                          calculateMinimumQuickRegEventDate(new Date())
                        }
                      />
                    </PopoverContent>
                  </Popover>
                  {errors.event_date && (
                    <p className="text-red-500 text-sm">{errors.event_date}</p>
                  )}
                </div>
                <div className="space-y-2">
                  {renderInput(
                    "reception_time",
                    t.fields.receptionTime,
                    t.placeholders.time,
                    formData.reception_time,
                    handleInputChange,
                    errors.reception_time,
                    "text",
                    false,
                    <Clock className="w-5 h-5" />,
                  )}
                  <p className="text-xs text-gray-500 px-1">
                    {t.placeholders.timeEstimation}
                  </p>
                </div>
                <div
                  className="md:col-span-2"
                  style={{
                    overflow: "visible",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  <div className="space-y-2" style={{ overflow: "visible" }}>
                    <Label className="text-gray-700 font-medium">
                      {t.fields.venue} *
                    </Label>
                    <GooglePlacesInput
                      value={formData.venue}
                      onChange={(venue, address, lat, lng) => {
                        handleInputChange("venue", venue);
                        handleInputChange("address", address);
                        handleInputChange("lat", lat);
                        handleInputChange("lng", lng);
                      }}
                      placeholder={t.placeholders.venueName}
                      error={errors.venue}
                      dir={isRTL ? "rtl" : "ltr"}
                    />
                    {errors.venue && (
                      <p className="text-red-500 text-sm">{errors.venue}</p>
                    )}
                    {renderInput(
                      "address",
                      t.fields.address,
                      t.placeholders.enterAddress,
                      formData.address,
                      handleInputChange,
                      errors.address,
                    )}
                  </div>
                </div>
              </div>
            )}
            {formStep === 2 && (
              <>
                {(formData.event_type === "wedding" ||
                  formData.event_type === "henna") && (
                  <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-8 p-4 border border-rose-100 rounded-xl">
                      <div className="space-y-4 md:col-span-2 border-b border-rose-100 pb-4 mb-4">
                        <h4 className="font-semibold text-gray-700">
                          {isRTL ? "צד א' (חתן/כלה) " : "Couple 1"} *
                        </h4>
                        {renderInput(
                          "couple_name_1",
                          t.fields.fullName,
                          t.placeholders.enterFullName,
                          formData.couple_name_1,
                          handleInputChange,
                          errors.couple_name_1,
                        )}
                        {renderInput(
                          "couple_phone_1",
                          t.fields.couplePhone1,
                          t.placeholders.phoneNumber,
                          formData.couple_phone_1,
                          handleInputChange,
                          errors.couple_phone_1,
                          "tel",
                          true,
                        )}
                        {renderInput(
                          "couple1_parent1_name",
                          t.fields.couple1Parent1,
                          t.placeholders.enterFullName,
                          formData.couple1_parent1_name,
                          handleInputChange,
                          errors.couple1_parent1_name,
                        )}
                        {renderInput(
                          "couple1_parent2_name",
                          t.fields.couple1Parent2,
                          t.placeholders.enterFullName,
                          formData.couple1_parent2_name,
                          handleInputChange,
                          errors.couple1_parent2_name,
                        )}
                      </div>
                      <div className="space-y-4 md:col-span-2">
                        <h4 className="font-semibold text-gray-700">
                          {isRTL ? "צד ב' (חתן/כלה)" : "Couple 2"} *
                        </h4>
                        {renderInput(
                          "couple_name_2",
                          t.fields.fullName,
                          t.placeholders.enterFullName,
                          formData.couple_name_2,
                          handleInputChange,
                          errors.couple_name_2,
                        )}
                        {renderInput(
                          "couple_phone_2",
                          t.fields.couplePhone2,
                          t.placeholders.phoneNumber,
                          formData.couple_phone_2,
                          handleInputChange,
                          errors.couple_phone_2,
                          "tel",
                          true,
                        )}
                        {renderInput(
                          "couple2_parent1_name",
                          t.fields.couple2Parent1,
                          t.placeholders.enterFullName,
                          formData.couple2_parent1_name,
                          handleInputChange,
                          errors.couple2_parent1_name,
                        )}
                        {renderInput(
                          "couple2_parent2_name",
                          t.fields.couple2Parent2,
                          t.placeholders.enterFullName,
                          formData.couple2_parent2_name,
                          handleInputChange,
                          errors.couple2_parent2_name,
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {formData.event_type === "bar_bat_mitzvah" && (
                  <div className="space-y-6">
                    <div className="p-4 border border-rose-100 rounded-xl space-y-6">
                      <div className="space-y-2">
                        <Label className="text-gray-700 font-medium">
                          {t.fields.mitzvahType} *
                        </Label>
                        <div className="flex gap-3">
                          <Button
                            type="button"
                            variant={
                              formData.mitzvah_type === "bar"
                                ? "default"
                                : "outline"
                            }
                            onClick={() =>
                              handleInputChange("mitzvah_type", "bar")
                            }
                            className={`flex-1 h-12 rounded-lg ${
                              formData.mitzvah_type === "bar"
                                ? "bg-rose-500 text-white border-rose-500"
                                : ""
                            }`}
                          >
                            {t.fields.barMitzvah}
                          </Button>
                          <Button
                            type="button"
                            variant={
                              formData.mitzvah_type === "bat"
                                ? "default"
                                : "outline"
                            }
                            onClick={() =>
                              handleInputChange("mitzvah_type", "bat")
                            }
                            className={`flex-1 h-12 rounded-lg ${
                              formData.mitzvah_type === "bat"
                                ? "bg-rose-500 text-white border-rose-500"
                                : ""
                            }`}
                          >
                            {t.fields.batMitzvah}
                          </Button>
                        </div>
                        {errors.mitzvah_type && (
                          <p className="text-red-500 text-sm">
                            {errors.mitzvah_type}
                          </p>
                        )}
                      </div>
                      {renderInput(
                        "child_name",
                        formData.mitzvah_type === "bar"
                          ? t.fields.childNameBar
                          : formData.mitzvah_type === "bat"
                            ? t.fields.childNameBat
                            : t.fields.childName,
                        t.placeholders.enterFullName,
                        formData.child_name,
                        handleInputChange,
                        errors.child_name,
                      )}
                      <h4 className="font-semibold text-gray-700 pt-2">
                        {t.fields.parentDetails}
                      </h4>
                      {renderInput(
                        "parent1_name",
                        t.fields.parent1Name,
                        t.placeholders.enterFullName,
                        formData.parent1_name,
                        handleInputChange,
                        errors.parent1_name,
                      )}
                      {renderInput(
                        "parent1_phone",
                        t.fields.parent1Phone,
                        t.placeholders.phoneNumber,
                        formData.parent1_phone,
                        handleInputChange,
                        errors.parent1_phone,
                        "tel",
                        true,
                      )}
                      {renderInput(
                        "parent2_name",
                        t.fields.parent2Name,
                        t.placeholders.enterFullName,
                        formData.parent2_name,
                        handleInputChange,
                        errors.parent2_name,
                      )}
                      {renderInput(
                        "parent2_phone",
                        t.fields.parent2Phone,
                        t.placeholders.phoneNumber,
                        formData.parent2_phone,
                        handleInputChange,
                        errors.parent2_phone,
                        "tel",
                        true,
                      )}
                    </div>
                  </div>
                )}
                {formData.event_type === "brit" && (
                  <div className="space-y-6">
                    <div className="p-4 border border-rose-100 rounded-xl space-y-6">
                      <div className="space-y-2">
                        <Label className="text-gray-700 font-medium">
                          {t.fields.britType} *
                        </Label>
                        <div className="flex gap-3">
                          <Button
                            type="button"
                            variant={
                              formData.brit_type === "boy"
                                ? "default"
                                : "outline"
                            }
                            onClick={() =>
                              handleInputChange("brit_type", "boy")
                            }
                            className={`flex-1 h-12 rounded-lg ${
                              formData.brit_type === "boy"
                                ? "bg-rose-500 text-white border-rose-500"
                                : ""
                            }`}
                          >
                            {t.fields.britMilah}
                          </Button>
                          <Button
                            type="button"
                            variant={
                              formData.brit_type === "girl"
                                ? "default"
                                : "outline"
                            }
                            onClick={() =>
                              handleInputChange("brit_type", "girl")
                            }
                            className={`flex-1 h-12 rounded-lg ${
                              formData.brit_type === "girl"
                                ? "bg-rose-500 text-white border-rose-500"
                                : ""
                            }`}
                          >
                            {t.fields.britBat}
                          </Button>
                        </div>
                        {errors.brit_type && (
                          <p className="text-red-500 text-sm">
                            {errors.brit_type}
                          </p>
                        )}
                      </div>
                      {renderInput(
                        "child_name",
                        formData.brit_type === "boy"
                          ? t.fields.childNameBritBoy
                          : formData.brit_type === "girl"
                            ? t.fields.childNameBritGirl
                            : t.fields.childName,
                        t.placeholders.enterFullName,
                        formData.child_name,
                        handleInputChange,
                        errors.child_name,
                      )}
                      <h4 className="font-semibold text-gray-700 pt-2">
                        {t.fields.parentDetails}
                      </h4>
                      {renderInput(
                        "parent1_name",
                        t.fields.parent1Name,
                        t.placeholders.enterFullName,
                        formData.parent1_name,
                        handleInputChange,
                        errors.parent1_name,
                      )}
                      {renderInput(
                        "parent1_phone",
                        t.fields.parent1Phone,
                        t.placeholders.phoneNumber,
                        formData.parent1_phone,
                        handleInputChange,
                        errors.parent1_phone,
                        "tel",
                        true,
                      )}
                      {renderInput(
                        "parent2_name",
                        t.fields.parent2Name,
                        t.placeholders.phoneNumber,
                        formData.parent2_name,
                        handleInputChange,
                        errors.parent2_name,
                      )}
                      {renderInput(
                        "parent2_phone",
                        t.fields.parent2Phone,
                        t.placeholders.phoneNumber,
                        formData.parent2_phone,
                        handleInputChange,
                        errors.parent2_phone,
                        "tel",
                        true,
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
            {formStep === 3 && (
              <div className="space-y-8">
                <div className="space-y-2 p-4 bg-rose-50 rounded-xl border border-rose-200">
                  <div className="flex items-center justify-between mb-2">
                    <Label className="text-gray-700 font-medium">
                      {t.fields.eventName}
                    </Label>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={() => setIsEditingEventName(!isEditingEventName)}
                      className="flex items-center gap-1 text-xs"
                    >
                      <Edit3 className="w-3 h-3" />
                      {isEditingEventName
                        ? t.buttons.cancelEdit
                        : t.buttons.editEventName}
                    </Button>
                  </div>
                  {isEditingEventName ? (
                    <Input
                      value={formData.event_name}
                      onChange={(e) =>
                        handleInputChange("event_name", e.target.value)
                      }
                      placeholder={t.placeholders.eventNameDefault}
                      className="h-12 rounded-xl border-2 border-gray-200 focus:border-rose-300"
                    />
                  ) : (
                    <p className="text-lg text-rose-700 font-semibold min-h-[48px] flex items-center">
                      {formData.event_name || t.placeholders.eventNameDefault}
                    </p>
                  )}
                </div>
                <div className="p-4 border border-rose-100 rounded-xl">
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-3">
                    <div className="flex items-center gap-3 mb-2 sm:mb-0">
                      <Gift className="w-6 h-6 text-rose-500" />
                      <Label className="text-gray-700 font-medium text-lg">
                        {t.fields.giftService}
                      </Label>
                    </div>
                    <div className="flex items-baseline gap-2 text-sm sm:text-base rtl:mr-auto ltr:ml-auto">
                      {eventTypeDetail.original_gift_charges >
                        eventTypeDetail.gift_charge && (
                        <span className="text-gray-500 line-through">
                          {isRTL ? "200 ₪" : "₪200"}
                        </span>
                      )}
                      <span className="text-rose-500 font-bold text-lg">
                        {isRTL
                          ? `${eventTypeDetail.gift_charge} ₪`
                          : `₪${eventTypeDetail.gift_charge}`}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <Button
                      type="button"
                      variant={
                        formData.activate_gift_service === true
                          ? "default"
                          : "outline"
                      }
                      onClick={() =>
                        handleInputChange("activate_gift_service", true)
                      }
                      className={`flex-1 h-12 rounded-lg transition-all duration-200 ${
                        formData.activate_gift_service === true
                          ? "bg-rose-500 text-white border-rose-500"
                          : "text-gray-700 border-gray-300 hover:bg-rose-50 hover:border-rose-400"
                      }`}
                    >
                      <Check
                        className={`w-5 h-5 ${isRTL ? "ml-2" : "mr-2"} ${
                          formData.activate_gift_service === true
                            ? "text-white"
                            : "text-green-500"
                        }`}
                      />
                      {t.buttons.yes}
                    </Button>
                    <Button
                      type="button"
                      variant={
                        formData.activate_gift_service === false
                          ? "default"
                          : "outline"
                      }
                      onClick={() =>
                        handleInputChange("activate_gift_service", false)
                      }
                      className={`flex-1 h-12 rounded-lg transition-all duration-200 ${
                        formData.activate_gift_service === false
                          ? "bg-gray-600 text-white border-gray-600"
                          : "text-gray-700 border-gray-300 hover:bg-gray-100 hover:border-gray-400"
                      }`}
                    >
                      <X
                        className={`w-5 h-5 ${isRTL ? "ml-2" : "mr-2"} ${
                          formData.activate_gift_service === false
                            ? "text-white"
                            : "text-red-500"
                        }`}
                      />
                      {t.buttons.no}
                    </Button>
                  </div>
                  {errors.activate_gift_service && (
                    <p className="text-red-500 text-sm mt-2">
                      {errors.activate_gift_service}
                    </p>
                  )}
                </div>
                <div className="space-y-4">
                  <Label
                    htmlFor="special_requests"
                    className="text-gray-700 font-medium"
                  >
                    {t.fields.specialRequests} (
                    {isRTL ? "אופציונלי" : "Optional"})
                  </Label>
                  <Textarea
                    id="special_requests"
                    value={formData.special_requests}
                    onChange={(e) =>
                      handleInputChange("special_requests", e.target.value)
                    }
                    className="rounded-xl border-2 border-gray-200 focus:border-rose-300 transition-all min-h-[100px] focus:ring-0 focus:outline-none"
                    placeholder={t.placeholders.specialRequests}
                  />
                </div>
                <div className="space-y-2 p-4 border border-rose-100 rounded-xl">
                  <div className="flex items-center gap-3 mb-2">
                    <FileText className="w-6 h-6 text-rose-500" />
                    <Label className="text-gray-700 font-medium text-lg">
                      {t.fields.termsAndConditions} *
                    </Label>
                  </div>
                  <div className="flex items-start gap-3 p-3 rounded-lg transition-colors hover:bg-rose-50/50">
                    <Checkbox
                      id="terms_agreed"
                      checked={formData.terms_agreed}
                      onCheckedChange={(checked) =>
                        handleInputChange("terms_agreed", checked)
                      }
                      className={`mt-1 h-5 w-5 rounded border-gray-300 text-rose-500 focus:ring-rose-400 data-[state=checked]:bg-rose-500 data-[state=checked]:border-rose-500 ${
                        errors.terms_agreed
                          ? "!border-red-400"
                          : "border-gray-300"
                      }`}
                    />
                    <div className="grid gap-1.5 leading-none flex-1">
                      <label
                        htmlFor="terms_agreed"
                        className="text-sm font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                      >
                        קראתי והבנתי את{" "}
                        <a
                          href="https://app.wiwi.co.il/terms"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-rose-500 hover:text-rose-600 underline font-semibold"
                        >
                          {t.fields.termsLink}
                        </a>{" "}
                        {isRTL ? "ומסכים/ה לתנאיו." : "and agree to its terms."}
                      </label>
                    </div>
                  </div>
                  {errors.terms_agreed && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.terms_agreed}
                    </p>
                  )}

                  {formData.activate_gift_service === true && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      className="flex items-start gap-3 p-3 mt-2 rounded-lg transition-colors hover:bg-rose-50/50"
                    >
                      <Checkbox
                        id="gift_terms_agreed"
                        checked={formData.gift_terms_agreed}
                        onCheckedChange={(checked) =>
                          handleInputChange("gift_terms_agreed", checked)
                        }
                        className={`mt-1 h-5 w-5 rounded border-gray-300 text-rose-500 focus:ring-rose-400 data-[state=checked]:bg-rose-500 data-[state=checked]:border-rose-500 ${
                          errors.gift_terms_agreed
                            ? "!border-red-400"
                            : "border-gray-300"
                        }`}
                      />
                      <div className="grid gap-1.5 leading-none flex-1">
                        <label
                          htmlFor="gift_terms_agreed"
                          className="text-sm font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                        >
                          קראתי והבנתי את{" "}
                          <a
                            href="https://app.wiwi.co.il/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-rose-500 hover:text-rose-600 underline font-semibold"
                          >
                            {t.fields.giftTermsLink}
                          </a>{" "}
                          {isRTL
                            ? "ומסכים/ה לתנאיו."
                            : "and agree to its terms."}
                        </label>
                      </div>
                    </motion.div>
                  )}
                  {errors.gift_terms_agreed && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.gift_terms_agreed}
                    </p>
                  )}
                </div>
              </div>
            )}
            {formStep === 4 && (
              <div className="space-y-6">
                <div className="p-4 bg-rose-50/70 rounded-xl border border-rose-200 text-sm text-rose-800 flex items-start gap-3">
                  <ShieldCheck
                    className={`w-8 h-8 md:w-6 md:h-6 text-rose-500 flex-shrink-0 mt-1 ${
                      isRTL ? "ml-3" : "mr-3"
                    }`}
                  />
                  <div>
                    <p className="leading-relaxed">
                      {t.fields.securityDetails}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="md:col-span-2">
                    {renderInput(
                      "credit_card_number",
                      t.fields.creditCard,
                      t.placeholders.creditCard,
                      formData.credit_card_number,
                      handleInputChange,
                      errors.credit_card_number,
                      "text",
                      false,
                      <CreditCard className="w-5 h-5" />,
                    )}
                  </div>
                  {renderInput(
                    "card_holder_id",
                    t.fields.cardHolderId,
                    t.placeholders.idNumber,
                    formData.card_holder_id,
                    handleInputChange,
                    errors.card_holder_id,
                  )}
                  {renderInput(
                    "card_holder_name",
                    t.fields.cardHolderName,
                    t.placeholders.fullNameOnCard,
                    formData.card_holder_name,
                    handleInputChange,
                    errors.card_holder_name,
                  )}
                  {renderInput(
                    "card_expiry",
                    t.fields.cardExpiry,
                    t.placeholders.cardExpiry,
                    formData.card_expiry,
                    handleInputChange,
                    errors.card_expiry,
                  )}
                  {renderInput(
                    "card_cvv",
                    t.fields.cardCvv,
                    t.placeholders.cvv,
                    formData.card_cvv,
                    handleInputChange,
                    errors.card_cvv,
                  )}
                </div>
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="pt-6 flex items-center gap-4">
        {(formStep > 0 || !isEventTypeFromUrl) && (
          <Button
            type="button"
            variant="outline"
            onClick={handlePrevStep}
            className="h-12 rounded-xl"
            disabled={isSubmitting || isSendingOtp}
          >
            {isRTL ? (
              <ArrowRight className="ml-2 w-5 h-5" />
            ) : (
              <ArrowLeft className="mr-2 w-5 h-5" />
            )}
            {t.buttons.back}
          </Button>
        )}
        {!isPhoneVerified && (
          <Button
            type="button"
            onClick={handleSendOtp}
            className="flex-1 h-12 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white text-lg font-semibold rounded-xl shadow-lg transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={
              (formStep === 0 &&
                isPhoneVerified &&
                !isPhoneFromUrl &&
                formData.client_phone.length > 0 &&
                /^\d{10}$/.test(
                  formData.client_phone.replace(/[^0-9]/g, ""),
                )) ||
              isSendingOtp
            }
          >
            {isSendingOtp ? (
              <Loader2
                className={`h-4 w-4 animate-spin ${isRTL ? "ml-1" : "mr-1"}`}
              />
            ) : (
              <KeyRound className={`h-4 w-4 ${isRTL ? "ml-1" : "mr-1"}`} />
            )}
            {isSendingOtp ? t.messages.otpSending : t.buttons.sendOtp}
          </Button>
        )}
        {isPhoneVerified && (
          <Button
            type="button"
            onClick={handleNextStep}
            className="flex-1 h-12 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white text-lg font-semibold rounded-xl shadow-lg transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={
              (formStep === 0 &&
                !isPhoneVerified &&
                !isPhoneFromUrl &&
                formData.client_phone.length > 0 &&
                /^\d{10}$/.test(
                  formData.client_phone.replace(/[^0-9]/g, ""),
                )) ||
              isSubmitting
            }
          >
            {formStep === formSteps.length - 1 ? (
              isSubmitting ? (
                <div className="flex items-center gap-3 justify-center">
                  <Loader2
                    className={`h-5 w-5 animate-spin ${
                      isRTL ? "ml-2" : "mr-2"
                    }`}
                  />
                  {t.messages.submitting}
                </div>
              ) : (
                t.buttons.submit
              )
            ) : (
              t.buttons.next
            )}
            {isRTL ? (
              <ArrowLeft className="mr-2 w-5 h-5" />
            ) : (
              <ArrowRight className="ml-2 w-5 h-5" />
            )}
          </Button>
        )}
      </div>
    </motion.div>
  );

  const renderFinalSummary = () => {
    const whatsappUrl = `https://wa.me/972539242324?text=${encodeURIComponent(
      isRTL
        ? "אני רוצה לדבר עם נציג"
        : "Hello, I am interested in WiWi service",
    )}`;

    return (
      <motion.div
        key="finalSummary"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl p-8 md:p-12"
      >
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            {t.finalSummary.title}
          </h2>
          <p className="text-gray-600 text-lg">{t.finalSummary.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8">
          <Button
            onClick={() => window.open("https://app.wiwi.co.il", "_blank")}
            className="w-full h-16 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white rounded-xl shadow-lg flex items-center justify-center gap-3 text-lg font-semibold mb-4"
          >
            <Users className="w-6 h-6" />
            {isRTL ? "מעבר למערכת" : "Go to System"}
          </Button>

          <Button
            onClick={handleDownloadPdf}
            className="h-16 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white rounded-xl shadow-lg flex items-center justify-center gap-3 text-lg font-semibold"
          >
            <Download className="w-6 h-6" />
            {t.finalSummary.downloadDealSummary}
          </Button>

          {/* <Button
            onClick={() => {
              invoices.forEach((inv) => {
                window.open(inv, "_blank");
              });
            }}
            className="h-16 bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white rounded-xl shadow-lg flex items-center justify-center gap-3 text-lg font-semibold"
          >
            <FileText className="w-6 h-6" />
            {t.finalSummary.downloadInvoice}
          </Button> */}

          <Button
            onClick={() => window.open("https://bit.ly/wiwiytb", "_blank")} // Placeholder for tutorial link
            className="h-16 bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-700 hover:to-pink-700 text-white rounded-xl shadow-lg flex items-center justify-center gap-3 text-lg font-semibold"
          >
            <Users className="w-6 h-6" />
            {t.finalSummary.watchTutorial}
          </Button>

          <Button
            onClick={() => window.open(whatsappUrl, "_blank")}
            className="h-16 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white rounded-xl shadow-lg flex items-center justify-center gap-3 text-lg font-semibold"
          >
            <Phone className="w-6 h-6" />
            {t.finalSummary.customerServiceWhatsapp}
          </Button>
        </div>

        {invoices && invoices.length > 0 && renderInvoicesTable()}
        <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-6 border-2 border-amber-200 mb-6">
          <div className="text-center mb-4">
            <Gift className="w-10 h-10 text-amber-600 mx-auto mb-3" />
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              {t.finalSummary.referralTitle}
            </h3>
            <p className="text-gray-600 text-sm">
              {t.finalSummary.referralDescription}
            </p>
          </div>

          {!showReferralForm ? (
            <div className="text-center">
              <Button
                onClick={() => setShowReferralForm(true)}
                className="h-12 bg-amber-500 hover:bg-amber-600 text-white rounded-xl px-8"
              >
                {t.finalSummary.interestedInReferral}
              </Button>
            </div>
          ) : !referralSubmitted ? (
            <div className="space-y-4">
              {referralFriends.map((friend, index) => (
                <div
                  key={index}
                  className="space-y-3 p-4 border border-amber-200 rounded-xl"
                >
                  <div className="flex justify-between items-center">
                    <h4 className="font-medium text-gray-700">
                      {isRTL ? `חבר ${index + 1}` : `Friend ${index + 1}`}
                    </h4>
                    {referralFriends.length > 1 && (
                      <Button
                        onClick={() => removeReferralField(index)}
                        variant="ghost"
                        size="sm"
                        className="text-red-600 hover:bg-red-50"
                      >
                        <Minus className="w-4 h-4" />
                      </Button>
                    )}
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <Input
                      type="text"
                      value={friend.name}
                      onChange={(e) =>
                        updateReferralFriend(index, "name", e.target.value)
                      }
                      placeholder={t.finalSummary.referralNamePlaceholder}
                      className="h-12 rounded-xl border-2 border-amber-300 focus:border-amber-400"
                      dir={isRTL ? "rtl" : "ltr"}
                    />
                    <Input
                      type="tel"
                      value={friend.phone}
                      onChange={(e) =>
                        updateReferralFriend(index, "phone", e.target.value)
                      }
                      placeholder={t.finalSummary.referralPhonePlaceholder}
                      className="h-12 rounded-xl border-2 border-amber-300 focus:border-amber-400"
                      dir={isRTL ? "rtl" : "ltr"}
                    />
                  </div>
                </div>
              ))}

              <div className="bg-amber-50 p-4 rounded-xl border border-amber-200">
                <div className="flex items-start gap-3">
                  <Checkbox
                    id="referral_terms"
                    checked={referralTermsAgreed}
                    onCheckedChange={setReferralTermsAgreed}
                    className="mt-1 h-5 w-5 rounded border-amber-300 text-amber-500 focus:ring-amber-400 data-[state=checked]:bg-amber-500 data-[state=checked]:border-amber-500"
                  />
                  <label
                    htmlFor="referral_terms"
                    className="text-sm text-gray-700 leading-relaxed cursor-pointer"
                  >
                    {t.finalSummary.referralDisclaimer}
                  </label>
                </div>
              </div>

              <div className="text-left">
                <Button
                  onClick={addReferralField}
                  variant="outline"
                  className="h-12 border-amber-300 text-amber-600 hover:bg-amber-50 px-6 rounded-xl w-auto inline-block ml-3"
                >
                  {t.finalSummary.addFriend}
                </Button>
                <button
                  onClick={
                    isSubmittingReferral ? undefined : handleReferralSubmit
                  }
                  disabled={
                    !referralFriends.some(
                      (friend) =>
                        friend.name.trim() &&
                        friend.phone &&
                        /^\d{10}$/.test(friend.phone.replace(/[^0-9]/g, "")),
                    ) ||
                    !referralTermsAgreed ||
                    isSubmittingReferral
                  }
                  className="h-12 bg-amber-500 hover:bg-amber-600 text-white rounded-xl px-8 whitespace-nowrap inline-flex items-center justify-center gap-2"
                >
                  {isSubmittingReferral ? (
                    <>
                      <Loader2 className={`w-4 h-4 animate-spin`} />
                      {isRTL ? "שולח..." : "Sending..."}
                    </>
                  ) : (
                    t.finalSummary.sendReferral
                  )}
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-white/70 rounded-xl p-4 text-center">
              <Check className="w-8 h-8 text-green-500 mx-auto mb-2" />
              <p className="font-semibold text-gray-800">
                {t.finalSummary.referralSuccess}
              </p>
            </div>
          )}
        </div>

        {/* <div className="text-center">
          <Button
            onClick={() => {
              setIsSubmitted(false);
              setCurrentStage(STAGES.SELECT_EVENT_TYPE);
              setFormData(initialFormData);
              setIsEventTypeFromUrl(false);
              setIsPhoneFromUrl(false);
              setIsPhoneVerified(false);
              setErrors({});
              setSubmittedData(null);
              setFormStep(0);
              setReferralFriends([{name: "", phone: ""}]);
              setReferralSubmitted(false);
              setReferralTermsAgreed(false);
              setShowReferralForm(false);
            }}
            variant="outline"
            className="h-12 px-8 rounded-xl border-2 border-gray-300 hover:bg-gray-50"
          >
            {t.buttons.newRegistration}
          </Button>
        </div> */}
      </motion.div>
    );
  };

  const renderPackageUnavailable = () => (
    <motion.div
      key="packageUnavailable"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl p-8 md:p-12 text-center"
    >
      <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
        <X className="w-10 h-10 text-white" />
      </div>

      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
        {t.packageUnavailable.title}
      </h2>

      <div className="space-y-4 text-gray-600 mb-8">
        <p className="text-lg">{t.packageUnavailable.message1}</p>
        <p>{t.packageUnavailable.message2}</p>
      </div>

      <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-xl p-6 mb-8">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          {t.packageUnavailable.contactInfo}
        </h3>
        <div className="space-y-2 text-gray-700">
          <p className="flex items-center justify-center gap-2">
            <Phone className="w-5 h-5 text-rose-500" />
            <span dir="ltr">03-1234567</span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <Mail className="w-5 h-5 text-rose-500" />
            <span dir="ltr">support@wiwi.co.il</span>
          </p>
        </div>
      </div>

      <Button
        onClick={() => (window.location.href = "https://wiwi.co.il")}
        className="bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white px-8 py-3 rounded-xl text-lg font-semibold"
      >
        {t.packageUnavailable.backToWebsite}
      </Button>
    </motion.div>
  );

  if (currentStage === STAGES.PACKAGE_UNAVAILABLE) {
    return (
      <div
        className={`min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 flex items-center justify-center p-4`}
        dir={isRTL ? "rtl" : "ltr"}
      >
        <div className="max-w-2xl mx-auto">{renderPackageUnavailable()}</div>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div
        className={`min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 py-8 px-4 pb-16`}
        dir={isRTL ? "rtl" : "ltr"}
      >
        {devMode && (
          <div className="fixed bottom-4 right-4 bg-black/80 text-white p-4 rounded-xl shadow-2xl z-50 max-w-xs">
            <div className="text-xs font-mono space-y-2">
              <div className="font-bold text-yellow-400 mb-2">🔧 DEV MODE</div>
              <div>Stage: {currentStage}</div>
              <div>
                Step:{" "}
                {currentStage === STAGES.FILL_DETAILS
                  ? `${formStep + 1}/${formSteps.length}`
                  : "N/A"}
              </div>
              <div className="pt-2 border-t border-gray-600">
                <div className="font-semibold mb-1">Quick Links:</div>
                <div className="space-y-1">
                  <a
                    href="?dev_mode=true&skip_to=summary&language=he"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Summary (HE)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=seating&language=he"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Seating (HE)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=form&language=he"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Form (HE)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=package_unavailable&language=he"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Unavailable (HE)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=summary&language=en"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Summary (EN)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=seating&language=en"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Seating (EN)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=form&language=en"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Form (EN)
                  </a>
                  <a
                    href="?dev_mode=true&skip_to=package_unavailable&language=en"
                    className="block text-blue-300 hover:text-blue-200"
                  >
                    → Unavailable (EN)
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-8"
          >
            <img
              src={logoImage}
              alt="WiWi Logo"
              className="h-16 md:h-20 mx-auto mb-6"
            />
          </motion.div>
          {renderFinalSummary()}
        </div>

        <footer className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-sm py-2 text-center border-t border-gray-200">
          <a
            href="https://wiwi.co.il/%D7%94%D7%A6%D7%94%D7%A8%D7%AA-%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA/"
            className="text-sm text-black hover:text-gray-700 transition-colors"
            aria-label="Accessibility Statement"
          >
            הצהרת נגישות
          </a>{" "}
          |{" "}
          <a
            href="https://wiwi.co.il/privacy-policy/"
            className="text-sm text-black hover:text-gray-700 transition-colors"
            aria-label="Privacy Policy"
          >
            מדיניות פרטיות
          </a>
        </footer>
      </div>
    );
  }
  if (expiryPageData.show)
    return (
      <ExpiryPage
        hash={packageHash}
        extendable={expiryPageData.extendable}
        language={currentLanguage}
        isRTL={isRTL}
      />
    );
  if (packageDetails === null) {
    return <></>;
  }
  return (
    <div
      className={`min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 py-8 px-4 pb-16`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      {devMode && (
        <div className="fixed bottom-4 right-4 bg-black/80 text-white p-4 rounded-xl shadow-2xl z-50 max-w-xs">
          <div className="text-xs font-mono space-y-2">
            <div className="font-bold text-yellow-400 mb-2">🔧 DEV MODE</div>
            <div>Stage: {currentStage}</div>
            <div>
              Step:{" "}
              {currentStage === STAGES.FILL_DETAILS
                ? `${formStep + 1}/${formSteps.length}`
                : "N/A"}
            </div>
            <div className="pt-2 border-t border-gray-600">
              <div className="font-semibold mb-1">Quick Links:</div>
              <div className="space-y-1">
                <a
                  href="?dev_mode=true&skip_to=summary&language=he"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Summary (HE)
                </a>
                <a
                  href="?dev_mode=true&skip_to=seating&language=he"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Seating (HE)
                </a>
                <a
                  href="?dev_mode=true&skip_to=form&language=he"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Form (HE)
                </a>
                <a
                  href="?dev_mode=true&skip_to=package_unavailable&language=he"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Unavailable (HE)
                </a>
                <a
                  href="?dev_mode=true&skip_to=summary&language=en"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Summary (EN)
                </a>
                <a
                  href="?dev_mode=true&skip_to=seating&language=en"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Seating (EN)
                </a>
                <a
                  href="?dev_mode=true&skip_to=form&language=en"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Form (EN)
                </a>
                <a
                  href="?dev_mode=true&skip_to=package_unavailable&language=en"
                  className="block text-blue-300 hover:text-blue-200"
                >
                  → Unavailable (EN)
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <img
            src={logoImage}
            alt="WiWi Logo"
            className="h-16 md:h-20 mx-auto mb-6"
          />
          <h2 className="text-2xl font-semibold text-gray-800">{t.appTitle}</h2>
          {/* <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">{t.appSubtitle}</p> */}
        </motion.div>

        <AnimatePresence mode="wait">
          {currentStage === STAGES.SELECT_EVENT_TYPE &&
            !isEventTypeFromUrl &&
            renderEventTypeSelection()}
          {currentStage === STAGES.FILL_DETAILS &&
            formData.event_type &&
            renderFormDetails()}
          {currentStage === STAGES.SEATING_SERVICE &&
            renderSeatingServiceOffer()}
        </AnimatePresence>
      </div>

      <Dialog open={showOtpPopup} onOpenChange={setShowOtpPopup}>
        <DialogContent
          className="sm:max-w-[425px] bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 rounded-2xl shadow-xl border-rose-200"
          dir={isRTL ? "rtl" : "ltr"}
        >
          <DialogHeader className="p-6 pb-4">
            <div className="flex justify-center mb-4">
              <KeyRound className="w-12 h-12 text-rose-500 p-2 bg-rose-100 rounded-full" />
            </div>
            <DialogTitle className="text-center text-xl font-semibold text-gray-800">
              {isRTL ? "אימות מספר טלפון" : "Phone Number Verification"}
            </DialogTitle>
            <DialogDescription className="text-center text-gray-600 px-4">
              {t.messages.otpSent}{" "}
              <span className="font-medium text-gray-700" dir="ltr">
                {formData.client_phone}
              </span>
              .
              <br />
              {t.messages.enterCode}).
            </DialogDescription>
          </DialogHeader>
          <div className="px-6 py-4 space-y-4">
            <Input
              id="otp"
              value={otpValue}
              onChange={(e) => setOtpValue(e.target.value)}
              placeholder={isRTL ? "הכנס קוד בן 6 ספרות" : "Enter 6-digit code"}
              className="h-14 text-center tracking-[0.3em] text-lg rounded-xl border-2 border-gray-200 focus:border-rose-300"
              maxLength={6}
              dir="ltr"
            />
            {otpError && (
              <p className="text-red-500 text-sm text-center pt-1">
                {otpError}
              </p>
            )}
          </div>
          <DialogFooter className="flex-col sm:flex-row-reverse sm:justify-start gap-2 p-6 pt-4">
            <Button
              type="button"
              onClick={handleVerifyOtp}
              disabled={isVerifyingOtp}
              className="w-full sm:w-auto bg-rose-500 hover:bg-rose-600 text-white h-12 rounded-lg"
            >
              {isVerifyingOtp ? (
                <Loader2
                  className={`h-5 w-5 animate-spin ${isRTL ? "ml-2" : "mr-2"}`}
                />
              ) : (
                <ShieldCheck className={`h-5 w-5 ${isRTL ? "ml-2" : "mr-2"}`} />
              )}
              {isVerifyingOtp ? t.messages.otpVerifying : t.buttons.verifyOtp}
            </Button>
            <Button
              type="button"
              variant="ghost"
              onClick={() => setShowOtpPopup(false)}
              className="w-full sm:w-auto text-gray-600 hover:text-gray-800 h-12 rounded-lg"
            >
              {t.buttons.close}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <footer className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-sm py-2 text-center border-t border-gray-200">
        <a
          href="https://wiwi.co.il/%D7%94%D7%A6%D7%94%D7%A8%D7%AA-%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA/"
          className="text-sm text-black hover:text-gray-700 transition-colors"
          aria-label="Accessibility Statement"
        >
          הצהרת נגישות
        </a>{" "}
        |{" "}
        <a
          href="https://wiwi.co.il/privacy-policy/"
          className="text-sm text-black hover:text-gray-700 transition-colors"
          aria-label="Privacy Policy"
        >
          מדיניות פרטיות
        </a>
      </footer>
    </div>
  );
}

function isInternationalPhoneNumber(number) {
  if (
    /^(43)\d{12}$/.test(number) ||
    /^(52|55|39|43|49)\d{11}$/.test(number) ||
    /^(1|44|49|1|92|549|54|55|57|43|20|30|91|62|39|81|52|63|7|10|90|234|244)\d{10}$/.test(
      number,
    ) ||
    /^(31|33|39|40|41|47|49|51|55|56|61|358|93|32|243|385|352|36|962|64|970|48|351|353|359|966|27|34|66|254|256|251|212|375|380|420|421|886|971|972|989|998)\d{9}$/.test(
      number,
    ) ||
    /^(39|45|47|65|370|852|965|350|352|357|356|467|506|507|598|974)\d{8}$/.test(
      number,
    ) ||
    /^(658|678)\d{7}$/.test(number)
  ) {
    return true;
  }

  return false;
}

RegistrationPage.propTypes = {
  shortLink: PropTypes.bool,
};
